var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _g, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoVehicles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 145,
    viewBox: "0 0 202 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.3723 30.9001H100.613C101.526 31.1033 102.506 31.342 103.54 31.6161H91.5967C92.2305 31.3307 92.8223 31.0904 93.3723 30.9001Z",
    fill: "url(#paint0_linear_32758_33488)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.3149 32.682H107.257C107.979 32.9056 108.714 33.1443 109.463 33.398H87.9215C88.3989 33.1464 88.8649 32.9077 89.3149 32.682Z",
    fill: "url(#paint1_linear_32758_33488)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9426 34.4723H112.619L115.256 35.1883H84.6799C85.11 34.9421 85.5309 34.7034 85.9426 34.4723Z",
    fill: "url(#paint2_linear_32758_33488)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8417 36.2622H119.21L121.847 36.9798H81.6499C82.0574 36.7347 82.4546 36.4955 82.8417 36.2622Z",
    fill: "url(#paint3_linear_32758_33488)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9002 38.0538H125.803L128.439 38.7699H78.7568C79.1417 38.5269 79.5228 38.2882 79.9002 38.0538Z",
    fill: "url(#paint4_linear_32758_33488)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0683 39.8439H132.392L135.027 40.56H75.962C76.3329 40.3181 76.7038 40.0794 77.0683 39.8439Z",
    fill: "url(#paint5_linear_32758_33488)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3221 41.634H138.99L141.618 42.3501H73.2416C73.6045 42.1098 73.9641 41.8663 74.3221 41.634Z",
    fill: "url(#paint6_linear_32758_33488)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M71.6402 43.4241H145.572L148.209 44.1402H70.5839L71.6402 43.4241Z",
    fill: "url(#paint7_linear_32758_33488)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M69.013 45.2158H152.163L154.8 45.9318H67.9761C68.3244 45.6942 68.6701 45.4555 69.013 45.2158Z",
    fill: "url(#paint8_linear_32758_33488)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4344 47.0057H158.754L159.473 47.2008C160.244 47.3395 161.086 47.5137 162.005 47.7217H65.4071L66.4344 47.0057Z",
    fill: "url(#paint9_linear_32758_33488)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M63.8978 48.8007H166.174C166.948 49.0217 167.746 49.2603 168.562 49.5167H62.8931L63.8978 48.8007Z",
    fill: "url(#paint10_linear_32758_33488)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3982 50.5857H171.784C172.429 50.8147 173.083 51.0534 173.745 51.3017H60.408L61.3982 50.5857Z",
    fill: "url(#paint11_linear_32758_33488)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9323 52.3758H176.463C177.023 52.608 177.583 52.8472 178.145 53.0934H57.955L58.9323 52.3758Z",
    fill: "url(#paint12_linear_32758_33488)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4989 54.1674H180.501C180.991 54.3996 181.48 54.6383 181.968 54.8834H55.5362C55.8555 54.6432 56.178 54.4045 56.4989 54.1674Z",
    fill: "url(#paint13_linear_32758_33488)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0945 55.9575H184.031C184.461 56.1908 184.891 56.4295 185.321 56.6735H53.1431C53.4591 56.4349 53.7768 56.1946 54.0945 55.9575Z",
    fill: "url(#paint14_linear_32758_33488)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M51.719 57.7476H187.134C187.516 57.9831 187.893 58.2217 188.262 58.4636H50.7691L51.719 57.7476Z",
    fill: "url(#paint15_linear_32758_33488)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M49.3629 59.5377H189.864C190.199 59.7732 190.53 60.0118 190.857 60.2537H48.4372L49.3629 59.5377Z",
    fill: "url(#paint16_linear_32758_33488)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0472 61.3293H192.255C192.549 61.5648 192.838 61.8035 193.123 62.0454H46.1248C46.4328 61.8051 46.7392 61.5664 47.0472 61.3293Z",
    fill: "url(#paint17_linear_32758_33488)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7508 63.1194H194.341C194.597 63.3549 194.847 63.5936 195.094 63.8355H43.8429L44.7508 63.1194Z",
    fill: "url(#paint18_linear_32758_33488)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4768 64.9096H196.134C196.349 65.1472 196.564 65.3858 196.779 65.6256H41.5786L42.4768 64.9096Z",
    fill: "url(#paint19_linear_32758_33488)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2304 66.7012H197.663C197.846 66.9383 198.027 67.185 198.201 67.4172H39.3386L40.2304 66.7012Z",
    fill: "url(#paint20_linear_32758_33488)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0083 68.4896H198.938C199.09 68.7266 199.238 68.9653 199.38 69.2072H37.1261L38.0083 68.4896Z",
    fill: "url(#paint21_linear_32758_33488)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8167 70.2812H199.985C200.105 70.5177 200.221 70.7564 200.333 70.9972H34.9394L35.8167 70.2812Z",
    fill: "url(#paint22_linear_32758_33488)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6394 72.0711H200.781C200.873 72.3087 200.959 72.5474 201.041 72.7871H32.7783L33.6394 72.0711Z",
    fill: "url(#paint23_linear_32758_33488)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4947 73.8614H201.369C201.433 74.0985 201.491 74.3452 201.546 74.5774H30.6432L31.4947 73.8614Z",
    fill: "url(#paint24_linear_32758_33488)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3758 75.6513H201.746C201.783 75.8884 201.814 76.1351 201.841 76.3673H28.5356L29.3758 75.6513Z",
    fill: "url(#paint25_linear_32758_33488)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2857 77.443H201.92C201.93 77.6806 201.935 77.9192 201.935 78.159H26.4633C26.731 77.9203 27.0083 77.6816 27.2857 77.443Z",
    fill: "url(#paint26_linear_32758_33488)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2231 79.2331H201.901C201.885 79.4696 201.864 79.7083 201.838 79.9491H24.4071L25.2231 79.2331Z",
    fill: "url(#paint27_linear_32758_33488)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1927 81.023H201.544L201.007 81.739H22.3896L23.1927 81.023Z",
    fill: "url(#paint28_linear_32758_33488)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M21.1946 82.8133H200.199L199.662 83.5293H20.406L21.1946 82.8133Z",
    fill: "url(#paint29_linear_32758_33488)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2321 84.6017H198.398L197.445 85.3177H18.458L19.2321 84.6017Z",
    fill: "url(#paint30_linear_32758_33488)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3083 86.3948H196.013L195.06 87.1108H16.5503C16.7997 86.8722 17.0524 86.6335 17.3083 86.3948Z",
    fill: "url(#paint31_linear_32758_33488)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4248 88.1849H193.631L192.678 88.9009H14.691L15.4248 88.1849Z",
    fill: "url(#paint32_linear_32758_33488)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M191.248 89.9748L190.294 90.6908H12.8686L13.5895 89.9748H191.248Z",
    fill: "url(#paint33_linear_32758_33488)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M187.913 92.4809H11.1077C11.3367 92.2433 11.5689 92.0047 11.8044 91.7649H188.858L187.913 92.4809Z",
    fill: "url(#paint34_linear_32758_33488)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M185.529 94.2773H9.40952C9.62454 94.0397 9.84818 93.8011 10.0804 93.5613H186.482L185.529 94.2773Z",
    fill: "url(#paint35_linear_32758_33488)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M183.147 96.0627H7.78697C7.99448 95.8251 8.20949 95.5864 8.43204 95.3466H184.1L183.147 96.0627Z",
    fill: "url(#paint36_linear_32758_33488)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M180.764 97.8528H6.25359C6.44925 97.6173 6.64975 97.3786 6.8551 97.1367H181.717L180.764 97.8528Z",
    fill: "url(#paint37_linear_32758_33488)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M178.286 99.6429H4.83582C5.0132 99.409 5.19543 99.1704 5.38734 98.9268H179.29C179.011 99.1268 178.675 99.3671 178.286 99.6429Z",
    fill: "url(#paint38_linear_32758_33488)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M175.766 101.433H3.56363C3.7249 101.201 3.88617 100.96 4.04744 100.717H176.763L175.766 101.433Z",
    fill: "url(#paint39_linear_32758_33488)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M173.229 103.224H3.00729V102.502H174.245L173.229 103.224Z",
    fill: "url(#paint40_linear_32758_33488)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M170.678 105.015H3.00713V104.298H171.7L170.678 105.015Z",
    fill: "url(#paint41_linear_32758_33488)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M168.112 106.804H3.75391C3.59618 106.575 3.4529 106.336 3.32494 106.088H169.14L168.112 106.804Z",
    fill: "url(#paint42_linear_32758_33488)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M165.534 108.595H5.18575C4.96535 108.349 4.75946 108.11 4.56808 107.879H166.566C166.227 108.116 165.882 108.354 165.534 108.595Z",
    fill: "url(#paint43_linear_32758_33488)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M162.939 110.386H6.92581C6.67424 110.143 6.43073 109.902 6.20012 109.669H163.979L162.939 110.386Z",
    fill: "url(#paint44_linear_32758_33488)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M160.331 112.178H8.87236C8.59822 111.936 8.33052 111.694 8.06604 111.462H161.376L160.331 112.178Z",
    fill: "url(#paint45_linear_32758_33488)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M157.706 113.966H10.993C10.6979 113.726 10.4077 113.483 10.1254 113.25H158.757L157.706 113.966Z",
    fill: "url(#paint46_linear_32758_33488)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M155.066 115.756H13.2701C12.954 115.518 12.6438 115.279 12.3396 115.04H156.121C155.773 115.282 155.422 115.521 155.066 115.756Z",
    fill: "url(#paint47_linear_32758_33488)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M152.412 117.547H15.7085C15.373 117.31 15.0419 117.071 14.7151 116.831H153.473L152.412 117.547Z",
    fill: "url(#paint48_linear_32758_33488)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M149.73 119.338H18.3064C17.9484 119.099 17.5941 118.861 17.2436 118.622H150.799L149.73 119.338Z",
    fill: "url(#paint49_linear_32758_33488)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M147.03 121.128H21.1061C20.7223 120.891 20.3406 120.652 19.9611 120.412H148.112L147.03 121.128Z",
    fill: "url(#paint50_linear_32758_33488)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M144.31 122.918H24.1491C23.7309 122.683 23.3138 122.444 22.8977 122.202H145.401L144.31 122.918Z",
    fill: "url(#paint51_linear_32758_33488)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M141.563 124.708H27.6081C27.1243 124.486 26.6346 124.247 26.139 123.992H142.665C142.297 124.231 141.929 124.471 141.563 124.708Z",
    fill: "url(#paint52_linear_32758_33488)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M138.788 126.5H32.3348L32.0268 126.414L32.0445 126.389C31.4468 126.209 30.8383 126.007 30.219 125.782H139.902L138.788 126.5Z",
    fill: "url(#paint53_linear_32758_33488)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M135.98 128.29H38.8807L36.2649 127.574H137.107L135.98 128.29Z",
    fill: "url(#paint54_linear_32758_33488)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M133.137 130.078H45.4087L42.7929 129.362H134.279L133.137 130.078Z",
    fill: "url(#paint55_linear_32758_33488)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M130.249 131.87H51.9431L49.3274 131.154H131.41L130.249 131.87Z",
    fill: "url(#paint56_linear_32758_33488)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M127.309 133.66H58.4874L55.8732 132.944H128.493C128.096 133.186 127.702 133.425 127.309 133.66Z",
    fill: "url(#paint57_linear_32758_33488)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M124.306 135.452H65.0266L62.4109 134.736H125.516L124.306 135.452Z",
    fill: "url(#paint58_linear_32758_33488)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M121.219 137.242H71.5642L68.9485 136.529H122.466L121.219 137.242Z",
    fill: "url(#paint59_linear_32758_33488)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M118.023 139.032H78.102L75.4863 138.316H119.317C118.881 138.56 118.45 138.799 118.023 139.032Z",
    fill: "url(#paint60_linear_32758_33488)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M114.663 140.822H84.6398L82.0257 140.106H116.032C115.567 140.353 115.113 140.591 114.663 140.822Z",
    fill: "url(#paint61_linear_32758_33488)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M111.031 142.614H91.1775L88.5634 141.896H112.529C112.016 142.148 111.517 142.387 111.031 142.614Z",
    fill: "url(#paint62_linear_32758_33488)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M95.2074 143.688H107.418C103.398 144.591 99.2276 144.591 95.2074 143.688Z",
    fill: "url(#paint63_linear_32758_33488)"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M153.726 46.9492L155.448 56.9977L164.972 59.7118L163.134 49.6004L160.792 42L153.726 46.9492Z",
    fill: "#636363"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1483 121.091C35.8037 121.449 27.8823 120.307 13.957 109.922C3.91826 102.434 0.971939 95.7304 0.109169 92.5825V99.2234C3.25707 103.828 8.37725 109.78 13.0104 113.155C24.0539 121.204 34.312 123.763 38.8129 124.702C43.3138 125.64 42.7978 120.699 39.1483 121.091Z",
    fill: "#3E3E3E"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3968 56.1592C38.3968 56.1592 28.7386 51.8437 28.7821 48.52C28.8257 45.1964 35.0908 49.2473 36.1342 50.1101C37.1776 50.9729 38.1791 54.0321 38.1791 54.0321L38.8757 54.5159V56.4736L38.3968 56.1592Z",
    fill: "url(#paint64_linear_32758_33488)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M158.614 51.3163L158.575 51.2937C156.397 50.0488 153.199 50.3261 149.631 52.3774C143.09 56.1543 137.786 64.5191 137.786 71.0552C137.786 73.9854 138.851 76.0544 140.613 77.1026L140.652 77.1252L140.691 77.1494L147.001 80.8247L161.744 71.3777L164.334 54.6771L158.614 51.3163Z",
    fill: "#2B2B2B"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M164.972 59.7116C164.972 65.601 160.199 73.1305 154.31 76.5316C149.644 79.2248 145.679 78.5168 144.232 75.1786C144.644 75.1237 145.025 74.9324 145.316 74.6351C145.664 74.2527 145.868 73.7603 145.891 73.2434C145.911 73.0338 145.935 72.8241 145.961 72.6161C146.185 71.0921 146.511 69.5875 146.682 68.0539L146.653 68.27C146.704 67.8394 146.732 67.4088 146.775 66.9799C146.822 66.757 146.886 66.5381 146.967 66.3251C147.309 65.5849 147.736 64.8866 148.065 64.1416C148.322 63.5594 148.591 62.9869 148.883 62.4257C148.955 62.3451 149.021 62.2594 149.081 62.1693C149.383 61.7242 149.66 61.263 149.973 60.826C150.122 60.6491 150.284 60.4831 150.457 60.3293C150.747 60.1342 151.06 59.9697 151.362 59.7907C151.781 59.5391 152.195 59.28 152.605 59.0134C153.411 58.4893 154.206 57.9409 154.995 57.3862C155.159 57.2729 155.312 57.1432 155.45 56.9992L155.572 56.9395C156.701 56.5057 157.891 56.2783 159.065 55.9977C159.755 55.8364 160.439 55.6881 161.142 55.58C161.87 55.4896 162.587 55.3303 163.284 55.1043L163.411 55.0559C164.402 56.1009 164.972 57.67 164.972 59.7116ZM161.249 61.8629C161.274 61.0343 161.087 60.213 160.704 59.4778C160.376 58.8719 159.851 58.3962 159.215 58.1296C158.514 57.854 157.75 57.7802 157.009 57.9168C156.054 58.0851 155.139 58.429 154.31 58.9311C153.322 59.5092 152.413 60.214 151.608 61.0276C150.774 61.8677 150.034 62.7968 149.402 63.7981C148.787 64.757 148.288 65.7855 147.915 66.8621C147.57 67.8309 147.386 68.8496 147.37 69.8778C147.345 70.7064 147.532 71.5277 147.915 72.2629C148.244 72.868 148.768 73.3434 149.402 73.6111C150.103 73.8851 150.866 73.9577 151.605 73.8208C152.561 73.6528 153.476 73.3088 154.306 72.8064C155.294 72.2287 156.202 71.5239 157.006 70.7099C157.841 69.8732 158.581 68.9467 159.212 67.9475C159.828 66.9886 160.327 65.9601 160.7 64.8834C161.047 63.9133 161.232 62.8929 161.249 61.8629Z",
    fill: "url(#paint65_linear_32758_33488)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M155.732 58.8409C154.458 59.5889 153.288 60.5003 152.25 61.5518C151.713 62.0903 151.205 62.6583 150.731 63.2531C150.256 63.8486 149.813 64.4693 149.405 65.1125C149.005 65.7437 148.64 66.3968 148.312 67.0687C147.997 67.7156 147.722 68.3812 147.488 69.0619C147.044 70.3107 146.807 71.6234 146.786 72.9484C146.786 74.1563 147.024 75.1916 147.488 76.0221C147.704 76.4123 147.983 76.7647 148.312 77.0655C148.635 77.356 149.005 77.5904 149.405 77.759C149.829 77.9322 150.275 78.0409 150.731 78.0815C151.238 78.1274 151.748 78.1095 152.25 78.0283C153.481 77.8104 154.661 77.367 155.73 76.7204C157.004 75.9725 158.174 75.0612 159.21 74.0095C159.747 73.4716 160.254 72.9041 160.728 72.3098C161.203 71.7144 161.645 71.0936 162.053 70.4504C162.454 69.819 162.819 69.166 163.147 68.4943C163.462 67.847 163.738 67.1807 163.971 66.4994C164.413 65.2532 164.648 63.9431 164.668 62.621C164.668 61.4131 164.432 60.3778 163.966 59.5456C163.75 59.156 163.471 58.8041 163.142 58.5039C162.819 58.2134 162.449 57.979 162.049 57.8104C161.625 57.6372 161.179 57.5285 160.723 57.4879C160.217 57.442 159.707 57.4599 159.206 57.5411C157.975 57.7585 156.795 58.2014 155.725 58.8474L155.732 58.8409ZM155.732 55.9381C162.273 52.1613 167.575 54.4029 167.575 60.9374C167.575 67.4718 162.273 75.8447 155.732 79.6216C149.191 83.3984 143.887 81.1568 143.887 74.6223C143.887 68.0879 149.186 59.7166 155.732 55.9397V55.9381Z",
    fill: "#3E3E3E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M155.732 60.3083C154.67 60.931 153.694 61.69 152.829 62.5661C151.93 63.468 151.133 64.4657 150.452 65.5414C149.789 66.5753 149.251 67.6839 148.849 68.8441C148.479 69.8882 148.281 70.9858 148.264 72.0936C148.264 73.1031 148.46 73.9675 148.849 74.6642C149.203 75.316 149.768 75.8279 150.452 76.1156C151.207 76.4125 152.031 76.4924 152.829 76.3462C153.856 76.1632 154.84 75.7926 155.732 75.2528C156.794 74.6262 157.77 73.864 158.635 72.9854C159.534 72.0842 160.331 71.0864 161.012 70.0101C161.674 68.9766 162.212 67.8685 162.615 66.709C162.986 65.6704 163.187 64.5784 163.208 63.4756C163.208 62.4661 163.01 61.6017 162.621 60.905C162.267 60.2532 161.702 59.7414 161.018 59.4536C160.263 59.1567 159.439 59.0769 158.641 59.223C157.614 59.4055 156.63 59.7762 155.738 60.3164L155.732 60.3083ZM155.732 58.7812C160.704 55.909 164.735 57.6136 164.735 62.5854C164.735 67.5572 160.704 73.9175 155.732 76.7881C150.76 79.6586 146.727 77.9556 146.727 72.9822C146.727 68.0088 150.758 61.6517 155.732 58.7812Z",
    fill: "url(#paint66_linear_32758_33488)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M161.249 69.6361C160.905 70.2133 160.524 70.7676 160.109 71.2955C159.703 71.8288 159.262 72.3347 158.789 72.8098C158.789 72.8098 159.53 72.0663 158.859 71.5196C158.188 70.9729 156.858 70.4553 156.858 70.4553L158.762 67.9911C158.762 67.9911 159.385 69.0861 160.213 69.7651C161.042 70.444 161.249 69.6361 161.249 69.6361Z",
    fill: "url(#paint67_linear_32758_33488)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M152.745 76.2994C152.308 76.3646 151.864 76.3646 151.428 76.2994C151.029 76.2583 150.642 76.1417 150.288 75.9559C150.288 75.9559 153.139 74.7819 153.81 73.4563C154.48 72.1307 155.261 70.0052 155.261 70.0052L157.166 70.2665C156.438 71.3547 155.77 72.4815 155.164 73.6418C154.334 75.2867 152.745 76.2994 152.745 76.2994Z",
    fill: "url(#paint68_linear_32758_33488)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M148.256 71.3777C148.32 70.2021 148.617 69.051 149.13 67.9911C149.13 67.9911 151.981 69.0974 153.087 68.7974C154.194 68.4975 156.029 67.6234 156.029 67.6234L155.36 70.2488C154.433 70.2862 153.514 70.4247 152.618 70.6617C151.246 71.0374 148.256 71.3777 148.256 71.3777Z",
    fill: "url(#paint69_linear_32758_33488)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M153.968 61.5161C154.441 61.1189 154.943 60.7577 155.471 60.4357C155.951 60.1285 156.458 59.8666 156.987 59.6535C156.987 59.6535 157.624 62.6821 157.669 63.8093C157.714 64.9366 158.127 66.4993 158.127 66.4993L155.787 67.9506C155.947 66.9228 156.021 65.8833 156.008 64.8431C155.95 63.4433 153.968 61.5161 153.968 61.5161Z",
    fill: "url(#paint70_linear_32758_33488)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M162.041 60.0504C162.33 60.3212 162.564 60.6454 162.729 61.0051C162.926 61.3923 163.062 61.8072 163.134 62.2356C163.134 62.2356 162.437 64.2159 161.36 65.2545C160.283 66.293 158.715 68.1734 158.715 68.1734L157.867 66.4785C158.878 65.7298 159.843 64.922 160.759 64.0595C162.087 62.7694 162.041 60.0504 162.041 60.0504Z",
    fill: "url(#paint71_linear_32758_33488)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M159.485 67.1719C159.485 68.5588 158.356 70.3327 156.974 71.1326C155.592 71.9325 154.463 71.4552 154.463 70.0715C154.463 68.6878 155.592 66.9107 156.974 66.1108C158.356 65.3109 159.485 65.7851 159.485 67.1719Z",
    fill: "url(#paint72_linear_32758_33488)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M157.088 70.0875C157.858 69.6424 158.461 68.6829 158.461 67.904C158.473 67.7374 158.441 67.5704 158.367 67.4208C158.292 67.2712 158.179 67.1445 158.038 67.0541C157.716 66.8735 157.291 66.9154 156.853 67.1686C156.082 67.6137 155.48 68.5732 155.48 69.3522C155.468 69.5188 155.5 69.6857 155.575 69.8354C155.649 69.985 155.762 70.1117 155.903 70.202C156.037 70.2772 156.188 70.3156 156.342 70.3133C156.606 70.3048 156.863 70.2269 157.088 70.0875ZM157.801 67.4637C157.868 67.5144 157.921 67.5817 157.954 67.6589C157.987 67.7361 157.999 67.8206 157.99 67.904C157.99 68.5104 157.469 69.3231 156.853 69.6779C156.567 69.8392 156.301 69.8843 156.14 69.7924C156.074 69.7402 156.022 69.6715 155.99 69.5931C155.958 69.5148 155.948 69.4295 155.959 69.3457C155.959 68.7394 156.48 67.9266 157.088 67.5718C157.242 67.4759 157.417 67.4204 157.598 67.4105C157.67 67.4066 157.741 67.4228 157.804 67.4573L157.801 67.4637Z",
    fill: "url(#paint73_linear_32758_33488)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M143.887 74.6223C143.887 68.0814 149.189 59.7165 155.732 55.9397C157.885 54.6963 159.906 54.1045 161.646 54.1045C162.573 54.0909 163.491 54.286 164.332 54.6754L162.478 53.5852C162.201 53.5559 161.924 53.5414 161.646 53.5417C159.756 53.5417 157.614 54.2012 155.45 55.451C152.208 57.3233 149.16 60.339 146.88 63.9433C144.6 67.5476 143.323 71.3615 143.323 74.6223C143.323 76.5429 143.768 78.1895 144.613 79.4393L146.521 80.552C144.876 79.4683 143.887 77.446 143.887 74.6223Z",
    fill: "#E4E4E4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M78.2809 111.455L71.7513 107.595C71.7513 107.595 64.8943 104.998 56.0069 114.468C45.1086 126.079 49.6515 106.405 49.6515 106.405L64.5218 94.4565L80.358 96.6319L81.7498 104.897L78.2809 111.455Z",
    fill: "#3E3E3E"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8753 103.868L73.8382 103.845C71.6595 102.6 68.46 102.87 64.8928 104.929C58.3519 108.706 53.0494 117.071 53.0494 123.611C53.0494 126.542 54.1122 128.611 55.8748 129.659L55.9135 129.682L55.9538 129.706L62.2642 133.381L77.007 123.926L79.6018 107.229L73.8753 103.868Z",
    fill: "#2B2B2B"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M0.109314 102.408V88.8783C0.109314 88.8783 -1.45818 79.6119 7.28563 72.0421C16.0294 64.4723 26.731 57.4267 31.1691 53.2499C35.6071 49.0731 47.8729 33.8029 53.3543 29.6277C58.8357 25.4526 97.9878 2.09164 103.6 1.56753C109.212 1.04342 115.737 4.18003 118.868 3.00118C120.76 2.29041 122.523 1.27679 124.089 3.05176e-05C124.089 3.05176e-05 135.7 0.261282 148.493 9.26634C161.286 18.2714 165.719 21.6677 165.85 31.5855V52.9935L163.108 56.6477C163.108 56.6477 163.378 46.2493 152.67 53.9256C141.962 61.6018 140.8 70.9987 140.01 73.9999C135.317 76.3495 78.2811 111.455 78.2811 111.455C78.2811 111.455 81.9354 97.7478 74.1043 99.8443C66.2733 101.941 56.2265 107.017 56.2265 127.638C52.1803 128.943 41.3481 132.336 27.3841 124.897C13.4202 117.458 0.109314 105.758 0.109314 102.408Z",
    fill: "url(#paint74_linear_32758_33488)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M30.9884 116.019C32.7188 116.526 34.4427 116.956 36.1763 117.309C37.897 117.665 39.6392 117.907 41.3916 118.035L42.0463 118.074C42.264 118.087 42.4834 118.087 42.7011 118.095C42.8091 118.095 42.9188 118.103 43.0236 118.104H43.3461C43.5638 118.104 43.7832 118.104 44.0009 118.104C44.8725 118.086 45.7425 118.02 46.6069 117.906L47.252 117.813C47.4681 117.777 47.681 117.73 47.8971 117.693C48.0051 117.672 48.1131 117.656 48.2196 117.632L48.5421 117.555L48.8646 117.48C48.9727 117.456 49.0791 117.432 49.1872 117.4C50.0475 117.166 50.8943 116.885 51.7239 116.558C51.3634 116.832 50.9864 117.084 50.595 117.313L50.2999 117.485C50.1999 117.542 50.1015 117.6 49.9983 117.646L49.3823 117.943C49.2791 117.996 49.1727 118.037 49.0598 118.079L48.7372 118.206L48.4147 118.332C48.3083 118.372 48.1986 118.403 48.0922 118.44C47.8745 118.511 47.6568 118.582 47.4358 118.646L46.7682 118.816C46.5473 118.877 46.3199 118.911 46.0941 118.958C45.8683 119.004 45.6426 119.045 45.4152 119.072C45.1878 119.099 44.9604 119.137 44.7314 119.162L44.046 119.22C43.817 119.245 43.588 119.241 43.359 119.253L43.0139 119.264C42.8994 119.264 42.7849 119.264 42.6704 119.264C42.4414 119.264 42.2124 119.264 41.9834 119.251L41.2981 119.217C39.4779 119.086 37.6784 118.748 35.9344 118.211C35.0671 117.946 34.2149 117.633 33.3815 117.276C32.9671 117.092 32.5559 116.906 32.1543 116.697C31.7546 116.49 31.3655 116.264 30.9884 116.019Z",
    fill: "#3E3E3E"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M136.017 76.3655L135.785 76.3284C135.795 76.2623 136.869 69.4956 138.423 63.7674C139.915 58.2699 144.611 54.1334 145.076 53.7351C145.435 50.3485 144.484 43.0497 144.43 42.6078L137.685 29.3405L137.896 29.2341L144.655 42.5433V42.5626C144.664 42.6401 145.687 50.3308 145.3 53.8077V53.8545L145.264 53.8851C145.213 53.927 140.194 58.1441 138.652 63.8287C137.091 69.5456 136.029 76.2978 136.017 76.3655ZM122.75 1.66412C123.734 1.68186 124.717 1.75766 125.699 1.86248C126.183 1.92537 126.68 1.97859 127.165 2.06245L127.898 2.17856C128.141 2.2221 128.381 2.27209 128.625 2.31725C130.567 2.69953 132.48 3.21739 134.35 3.86701C136.221 4.51234 138.048 5.28111 139.818 6.16827C140.039 6.27793 140.265 6.38114 140.484 6.4908L141.129 6.84558L141.783 7.19875C142 7.31809 142.22 7.43259 142.428 7.56321L143.703 8.32277L144.026 8.51145L144.337 8.71465L144.958 9.1291C148.26 11.3016 151.393 13.7211 154.331 16.3667C155.791 17.6996 157.164 19.1243 158.443 20.6322L158.915 21.203C159.069 21.3982 159.215 21.5965 159.367 21.7917C159.672 22.1803 159.951 22.5899 160.23 22.9963C160.37 23.1995 160.496 23.4124 160.628 23.6204C160.76 23.8284 160.883 24.0445 161.004 24.2655C161.249 24.6936 161.46 25.1407 161.634 25.6024C161.434 25.1542 161.197 24.7227 160.928 24.3122C160.794 24.1058 160.667 23.8962 160.523 23.6978C160.38 23.4995 160.246 23.293 160.096 23.0979L159.649 22.5125C159.506 22.3158 159.341 22.1319 159.186 21.9416C159.031 21.7513 158.877 21.5627 158.717 21.3772L158.225 20.8289C158.064 20.6483 157.903 20.4612 157.732 20.2838L157.22 19.7549L156.711 19.2259L156.182 18.7147L155.653 18.2035L155.388 17.9487L155.116 17.702L154.024 16.7086C153.658 16.386 153.276 16.0748 152.903 15.7571C152.531 15.4394 152.16 15.112 151.775 14.8185C151.002 14.2122 150.246 13.5881 149.449 13.014L148.269 12.1335C148.075 11.9851 147.873 11.8432 147.672 11.7029L147.07 11.2804L145.866 10.4337L145.564 10.2225L145.256 10.0225L144.64 9.62257L144.027 9.2178L143.721 9.01621L143.398 8.82753L142.141 8.06958C141.932 7.94057 141.716 7.82608 141.495 7.70835L140.85 7.35518L140.205 7.00201C139.988 6.88751 139.768 6.77946 139.551 6.66819C139.112 6.45048 138.68 6.22148 138.236 6.01345L136.901 5.40226C136.454 5.20229 135.996 5.02651 135.546 4.8346C135.096 4.64269 134.635 4.47659 134.177 4.30243C132.34 3.61701 130.461 3.04875 128.552 2.60108C128.314 2.54625 128.068 2.48819 127.835 2.43981L127.114 2.29467C126.63 2.18985 126.146 2.1205 125.662 2.03181C124.706 1.87216 123.73 1.74476 122.75 1.66412Z",
    fill: "#3E3E3E"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M165.85 31.5854C165.85 31.1435 165.835 30.7135 165.806 30.2953C165.408 31.5193 164.644 32.7272 163.362 33.8431C156.371 39.9615 154.877 40.1954 154.877 40.1954C154.877 40.1954 160.441 41.6145 165.843 38.3311L165.85 31.5854Z",
    fill: "#3E3E3E"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M27.4615 63.153C27.4615 63.153 17.005 76.3639 16.6116 83.1145C16.6116 81.1664 19.3531 71.3228 27.139 62.1322C27.1375 62.4978 27.2503 62.8547 27.4615 63.153ZM32.7074 92.0196C32.7074 92.0196 50.3918 91.1568 60.5274 82.0018L60.7031 83.6305C60.7031 83.6305 48.1373 92.6872 32.7074 92.0196Z",
    fill: "#3E3E3E"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6986 87.1237C110.702 68.9588 157.075 33.2723 157.662 32.8192C157.857 32.6834 158.01 32.4965 158.106 32.2791C158.201 32.0617 158.235 31.8223 158.203 31.5871C158.173 31.3515 158.079 31.1288 157.929 30.9446C157.779 30.7603 157.581 30.622 157.356 30.5453C155.498 29.8906 151.146 28.3586 144.268 28.5505C136.13 28.7779 126.786 31.3 116.496 36.0461C106.075 40.8534 96.883 49.4456 89.1794 61.5776C84.6639 68.6991 80.7065 77.0188 77.7473 85.64C77.5263 86.2851 77.6586 86.9624 78.0698 87.285C78.2428 87.417 78.4553 87.4869 78.6729 87.4833C79.0421 87.4639 79.398 87.3391 79.6986 87.1237ZM157.277 30.7679C157.46 30.8329 157.621 30.947 157.743 31.0977C157.865 31.2483 157.943 31.4296 157.968 31.6218C157.994 31.8139 157.966 32.0094 157.888 32.1868C157.81 32.3642 157.684 32.5166 157.525 32.6273C157.056 32.9966 110.612 68.7378 79.576 86.9221C79.0116 87.2833 78.5278 87.3462 78.2133 87.0995C77.8988 86.8528 77.7811 86.269 77.9714 85.7174C81.8418 74.4144 93.3739 46.9718 116.596 36.2606C129.36 30.3712 138.807 28.7569 145.49 28.7569C151.563 28.7569 155.356 30.0938 157.277 30.7679Z",
    fill: "#3E3E3E"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M152.989 33.8513C152.989 33.8513 112.113 65.3707 84.5479 81.523C83.2368 82.3616 82.661 81.2859 82.9836 80.3442C85.7799 72.1954 95.3607 49.07 116.709 39.2215C137.78 29.502 148.864 30.668 152.745 32.029C152.925 32.0918 153.084 32.2033 153.204 32.3509C153.325 32.4985 153.402 32.6766 153.427 32.8654C153.452 33.0542 153.425 33.2462 153.347 33.4203C153.27 33.5943 153.146 33.7435 152.989 33.8513ZM54.1413 31.7404L34.5911 52.1646C33.9675 52.8145 33.4798 53.5823 33.1566 54.4229C32.8333 55.2636 32.681 56.1603 32.7084 57.0605C32.7359 57.9608 32.9427 58.8465 33.3166 59.6659C33.6905 60.4853 34.2241 61.2218 34.8862 61.8325C43.9622 70.2183 64.2365 79.7781 67.3425 80.3522C71.8821 81.1908 75.1541 79.412 76.8394 76.7737L90.8824 54.7884C90.9935 54.6141 91.0669 54.4186 91.0979 54.2142C91.1289 54.0099 91.1169 53.8013 91.0625 53.6019C91.0081 53.4025 90.9127 53.2167 90.7822 53.0564C90.6518 52.896 90.4892 52.7648 90.305 52.671C84.5495 49.7457 63.4156 38.7683 56.2522 31.7065C56.1121 31.5688 55.946 31.4603 55.7636 31.3874C55.5812 31.3145 55.3861 31.2786 55.1897 31.2817C54.9932 31.2849 54.7994 31.327 54.6194 31.4058C54.4394 31.4845 54.2769 31.5983 54.1413 31.7404Z",
    fill: "#E2E2E2"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2136 32.1079C55.1233 32.106 55.0335 32.1231 54.9501 32.1581C54.8668 32.1931 54.7917 32.2452 54.7298 32.3111L35.1861 52.7354C34.6394 53.3066 34.2119 53.9811 33.9286 54.7193C33.6453 55.4575 33.5118 56.2448 33.536 57.0351C33.5601 57.8255 33.7415 58.6031 34.0693 59.3226C34.3972 60.0422 34.8651 60.6892 35.4457 61.226C44.4766 69.5731 64.5928 79.0071 67.4924 79.5409C68.1687 79.6691 68.8553 79.735 69.5437 79.7377C70.9384 79.7604 72.3159 79.4274 73.5463 78.7701C74.6022 78.1868 75.4953 77.3486 76.1443 76.3317L90.1873 54.3448C90.2369 54.2674 90.2697 54.1804 90.2836 54.0895C90.2976 53.9985 90.2923 53.9057 90.2681 53.817C90.244 53.7282 90.2015 53.6455 90.1434 53.5742C90.0853 53.5029 90.0129 53.4446 89.9308 53.403C83.7125 50.2519 62.8689 39.3842 55.6732 32.295C55.6128 32.235 55.541 32.1876 55.4621 32.1555C55.3833 32.1234 55.2988 32.1072 55.2136 32.1079ZM55.2136 31.2822C55.6024 31.2818 55.9756 31.4348 56.2522 31.708C63.4156 38.7649 84.5494 49.7423 90.305 52.6725C90.4896 52.7662 90.6526 52.8976 90.7833 53.0581C90.9141 53.2187 91.0098 53.4049 91.0642 53.6047C91.1186 53.8045 91.1305 54.0135 91.0992 54.2182C91.0678 54.4229 90.994 54.6187 90.8823 54.7931L76.8393 76.7784C75.4412 78.9571 72.948 80.5698 69.5437 80.5698C68.805 80.5677 68.0682 80.4975 67.3424 80.3601C64.2284 79.786 43.9589 70.2246 34.8861 61.8404C34.2241 61.2297 33.6905 60.4932 33.3166 59.6738C32.9426 58.8544 32.7359 57.9687 32.7084 57.0685C32.6809 56.1682 32.8333 55.2715 33.1565 54.4309C33.4798 53.5902 33.9674 52.8225 34.591 52.1726L54.1412 31.7402C54.2797 31.5953 54.4461 31.4799 54.6304 31.4012C54.8148 31.3225 55.0132 31.282 55.2136 31.2822Z",
    fill: "#343434"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M107.497 2.86744L119.431 4.36882C119.523 4.38011 119.615 4.38979 119.707 4.39624C121.529 4.54299 142.466 6.54913 153.734 22.4435C153.932 22.7243 154.048 23.0551 154.069 23.3984C154.09 23.7417 154.014 24.0839 153.85 24.3865C153.687 24.6891 153.442 24.94 153.144 25.111C152.845 25.282 152.505 25.3663 152.162 25.3543C148.386 25.2317 144.382 24.956 142.221 24.7931C141.222 24.7192 140.283 24.2855 139.58 23.5723C136.47 20.418 126.167 11.0646 107.289 3.68022C107.193 3.64283 107.114 3.57144 107.067 3.47956C107.019 3.38768 107.007 3.28167 107.033 3.18158C107.059 3.08149 107.12 2.99426 107.206 2.93637C107.291 2.87849 107.395 2.85396 107.497 2.86744Z",
    fill: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1094 107.527C31.1094 107.527 31.677 105.722 33.8235 104.361C35.9699 103 51.6449 101.981 51.6449 101.981C52.0997 101.924 52.5612 102.002 52.972 102.205C53.3828 102.409 53.7248 102.728 53.9553 103.125C54.1858 103.521 54.2947 103.976 54.2684 104.434C54.2421 104.891 54.0818 105.331 53.8075 105.698L52.1609 107.903C50.0467 110.736 47.3794 111.813 42.8205 111.954C38.2615 112.094 32.2043 109.64 32.2043 109.64C31.9776 109.6 31.763 109.508 31.5774 109.372C31.3918 109.236 31.2401 109.059 31.1342 108.854C31.0282 108.65 30.9709 108.424 30.9666 108.193C30.9623 107.963 31.0111 107.735 31.1094 107.527Z",
    fill: "white"
  }))), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M53.1574 101.089C53.0539 101.089 52.9505 101.096 52.8478 101.109C52.8478 101.109 37.1728 102.128 35.0263 103.487C32.8799 104.847 32.3123 106.653 32.3123 106.653C32.214 106.861 32.1651 107.089 32.1695 107.319C32.1738 107.55 32.2311 107.776 32.3371 107.98C32.443 108.184 32.5947 108.362 32.7803 108.498C32.9659 108.634 33.1805 108.726 33.4073 108.765C33.4073 108.765 39.1322 111.086 43.6412 111.086C43.7686 111.086 43.8976 111.086 44.0234 111.086C48.5823 110.946 51.2496 109.87 53.3654 107.037L55.0071 104.824C55.2656 104.478 55.4231 104.067 55.4621 103.637C55.5011 103.207 55.4201 102.774 55.2282 102.387C55.0362 102 54.7408 101.674 54.3747 101.445C54.0086 101.216 53.5861 101.093 53.1542 101.089H53.1574ZM53.1574 100.567C53.6861 100.571 54.2034 100.721 54.6517 101.001C55.1001 101.281 55.4621 101.68 55.6974 102.154C55.9328 102.627 56.0324 103.157 55.9851 103.683C55.9379 104.21 55.7456 104.713 55.4297 105.137L53.7831 107.34C52.6543 108.849 51.3948 109.868 49.816 110.541C48.3017 111.186 46.4665 111.523 44.0395 111.599C43.9088 111.599 43.775 111.599 43.6412 111.599C39.2531 111.599 33.8669 109.502 33.2605 109.261C32.9636 109.2 32.6843 109.073 32.4431 108.89C32.2019 108.706 32.0052 108.471 31.8675 108.201C31.7297 107.931 31.6546 107.634 31.6475 107.331C31.6405 107.028 31.7018 106.727 31.8268 106.451C31.9252 106.166 32.609 104.394 34.7474 103.039C35.1038 102.813 35.8923 102.463 38.6339 102.018C40.211 101.763 42.2494 101.508 44.6894 101.26C48.7097 100.852 52.5301 100.597 52.7994 100.58C52.9182 100.565 53.0378 100.558 53.1574 100.559V100.567Z",
    fill: "#3E3E3E"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3123 106.653C32.3123 106.653 32.8799 104.848 35.0264 103.487C37.1728 102.126 52.8478 101.108 52.8478 101.108C53.3015 101.052 53.7618 101.13 54.1715 101.333C54.5812 101.536 54.9223 101.855 55.1526 102.25C55.3829 102.645 55.4922 103.098 55.4669 103.555C55.4416 104.011 55.2829 104.45 55.0104 104.818L53.3655 107.024C51.2497 109.857 48.5824 110.933 44.0234 111.073C39.4644 111.213 33.4073 108.759 33.4073 108.759C33.1814 108.719 32.9677 108.627 32.7828 108.492C32.5978 108.356 32.4466 108.179 32.3407 107.976C32.2349 107.772 32.1773 107.547 32.1724 107.318C32.1674 107.088 32.2153 106.861 32.3123 106.653Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M0.499597 82.9582C0.47702 83.0582 0.454437 83.1566 0.433473 83.2533C0.449599 83.1501 0.472182 83.0582 0.499597 82.9582Z",
    fill: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M5.84379 73.4129C5.7809 73.471 5.72123 73.5307 5.66156 73.5887C1.51543 77.9219 0.339795 82.5567 0.072094 85.5723C1.80086 88.9912 4.98264 92.1971 4.98264 92.1971C5.11034 92.3888 5.28056 92.5485 5.48006 92.6636C5.67956 92.7787 5.90294 92.8463 6.13282 92.861C6.36269 92.8756 6.59286 92.837 6.80538 92.7482C7.0179 92.6593 7.20704 92.5226 7.35807 92.3487C7.39798 90.2757 7.3102 88.2022 7.09521 86.14C6.81461 83.2292 6.13084 76.3141 5.84379 73.4129Z",
    fill: "white"
  }))), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05818 72.6679L7.02107 72.2792C4.90482 74.1306 3.17615 76.3827 1.93477 78.9056C3.07694 76.5785 4.63764 74.4816 6.53889 72.7195C6.82594 75.6222 7.50648 82.5357 7.79192 85.4449C8.00698 87.5071 8.09423 89.5806 8.05317 91.6536C7.90242 91.8276 7.71353 91.9644 7.5012 92.0534C7.28888 92.1424 7.05887 92.1811 6.82911 92.1666C6.59936 92.1521 6.37607 92.0847 6.17663 91.9697C5.9772 91.8547 5.80701 91.6952 5.67935 91.5037C5.67935 91.5037 1.84285 87.6333 0.305994 83.8694C0.323733 83.771 0.343081 83.671 0.362432 83.571C0.27535 84.0064 0.201162 84.4225 0.156009 84.816C1.78963 88.2284 4.89237 91.4472 5.27457 91.8375C5.4508 92.0879 5.68172 92.295 5.94985 92.4429C6.21798 92.5909 6.51628 92.6758 6.82213 92.6914C7.12797 92.7069 7.43334 92.6526 7.71509 92.5326C7.99684 92.4126 8.24758 92.23 8.44828 91.9987L8.56278 91.8584V91.6746C8.60494 89.5779 8.51661 87.4806 8.2983 85.3949C8.02737 82.4663 7.34039 75.5174 7.05818 72.6679ZM0.425329 83.2662C0.404365 83.3662 0.383399 83.4662 0.364047 83.5629C0.383399 83.4726 0.404365 83.3662 0.425329 83.2662ZM1.1865 80.6602C1.14618 80.7682 1.10748 80.8746 1.07039 80.9827C1.10748 80.8746 1.14457 80.7682 1.1865 80.6602ZM1.76543 79.2636C1.71275 79.3786 1.659 79.4931 1.60417 79.6071C1.65792 79.4964 1.71168 79.3819 1.76543 79.2636ZM1.93316 78.9072C1.87618 79.0233 1.82242 79.1394 1.77189 79.2555C1.8235 79.1394 1.87725 79.0233 1.93316 78.9072ZM1.45741 79.9683C1.41065 80.078 1.36711 80.1893 1.32357 80.2989C1.36711 80.1893 1.41065 80.0861 1.45741 79.9683ZM1.06393 81.002C1.02684 81.1069 0.991359 81.2101 0.957493 81.3133C0.983295 81.2149 1.02684 81.1069 1.06393 81.002ZM0.949441 81.3391C0.915576 81.4423 0.883325 81.5439 0.851072 81.6471C0.883325 81.5374 0.915576 81.4423 0.949441 81.3391Z",
    fill: "#3E3E3E"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53885 72.7179C2.46689 76.5479 0.883284 80.7215 0.305953 83.8678C1.84281 87.6365 5.67931 91.5021 5.67931 91.5021C5.80697 91.6936 5.97716 91.8531 6.17659 91.9681C6.37602 92.0831 6.59932 92.1505 6.82907 92.165C7.05883 92.1796 7.28884 92.1408 7.50116 92.0518C7.71349 91.9628 7.90237 91.826 8.05313 91.652C8.09419 89.5791 8.00694 87.5055 7.79188 85.4433C7.50967 82.5341 6.8259 75.619 6.53885 72.7179Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3633 114.123L8.91903 104.627V100.365L25.3633 109.859V114.123Z",
    fill: "white"
  }))), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M146.195 31.9548C140.828 31.9548 131.416 33.3465 117.054 39.9713C108.023 44.1417 100.121 51.1761 93.5738 60.881C89.4792 67.0146 86.1827 73.645 83.764 80.6118C83.7181 80.7345 83.7091 80.8679 83.7382 80.9956C83.8682 80.9636 83.9915 80.909 84.1027 80.8344C98.3408 72.4905 116.165 59.9908 128.612 50.9696C142.111 41.1921 152.378 33.282 152.479 33.203L152.495 33.1917L152.511 33.1804C152.544 33.1593 152.569 33.1293 152.584 33.094C152.599 33.0588 152.604 33.0199 152.597 32.9821C152.593 32.9451 152.579 32.91 152.555 32.8813C152.532 32.8526 152.5 32.8315 152.465 32.8208C151.555 32.4983 149.528 31.9613 146.188 31.9613L146.195 31.9548ZM146.195 31.1308C149.281 31.1308 151.428 31.571 152.747 32.0355C152.925 32.099 153.083 32.2104 153.202 32.3575C153.321 32.5045 153.397 32.6816 153.422 32.8692C153.447 33.0567 153.42 33.2476 153.344 33.4209C153.268 33.5941 153.146 33.743 152.99 33.8513C152.99 33.8513 112.114 65.3706 84.5494 81.523C84.2994 81.7027 84.0036 81.8078 83.6963 81.8262C83.0045 81.8262 82.7448 81.0472 82.9851 80.3441C85.7815 72.1954 95.3622 49.0699 116.711 39.2214C130.629 32.7999 140.189 31.1292 146.195 31.1292V31.1308Z",
    fill: "#343434"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M143.05 42.5546L137.366 30.5791L139.73 29.4712L145.414 41.4467L143.05 42.5546Z",
    fill: "url(#paint75_linear_32758_33488)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M110.446 4.06875C127.378 11.1644 136.803 19.5809 140.175 22.9932C140.74 23.5619 141.491 23.9073 142.291 23.9657C144.363 24.1269 148.406 24.4011 152.197 24.5253H152.234C152.423 24.5267 152.608 24.4753 152.768 24.377C152.929 24.2786 153.059 24.1373 153.144 23.9689C153.231 23.804 153.27 23.6179 153.257 23.4318C153.244 23.2456 153.179 23.0669 153.07 22.9158C150.546 19.3567 147.314 16.2282 143.465 13.6157C140.174 11.4142 136.625 9.62525 132.898 8.28907C126.183 5.83945 120.679 5.30243 119.644 5.22503C119.538 5.21696 119.431 5.20567 119.331 5.19277L110.442 4.0752L110.446 4.06875ZM107.436 2.86249H107.498L119.431 4.36387C119.523 4.37516 119.615 4.38483 119.707 4.39128C121.529 4.53803 142.466 6.54418 153.734 22.4385C153.929 22.7149 154.045 23.0397 154.068 23.3774C154.092 23.7152 154.022 24.0528 153.866 24.3534C153.71 24.654 153.475 24.9061 153.186 25.082C152.897 25.2579 152.565 25.351 152.226 25.351H152.162C148.386 25.2268 144.382 24.9526 142.221 24.7897C141.222 24.7159 140.283 24.2822 139.58 23.569C136.471 20.4178 126.167 11.0644 107.29 3.6801C107.199 3.64378 107.124 3.57733 107.076 3.49198C107.029 3.40662 107.013 3.30758 107.03 3.21154C107.047 3.1155 107.097 3.02834 107.171 2.96476C107.245 2.90118 107.339 2.86506 107.436 2.86249Z",
    fill: "#343434"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M38.134 121.091C34.7893 121.449 26.868 120.307 12.9443 109.922C5.25521 104.189 1.7267 98.917 0.109211 95.3466V100.657C3.27485 105.011 7.83223 110.122 11.9945 113.155C23.0363 121.204 33.296 123.763 37.797 124.702C42.2979 125.64 41.7834 120.699 38.134 121.091Z",
    fill: "white"
  }))), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1483 121.091C35.8037 121.449 27.8823 120.307 13.957 109.922C3.91826 102.434 0.971939 95.7304 0.109169 92.5825V99.2234C3.25707 103.828 8.37725 109.78 13.0104 113.155C24.0539 121.204 34.312 123.763 38.8129 124.702C43.3138 125.64 42.7978 120.699 39.1483 121.091Z",
    fill: "#3E3E3E"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M116.822 67.7153V69.02L119.867 67.2622V68.3798L122.347 66.9477V65.8318V65.6431V64.5255L116.822 67.7153Z",
    fill: "#343434"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0728 110.576C50.3305 110.001 51.9625 108.898 53.3575 107.029L55.0072 104.824C55.2797 104.457 55.4384 104.018 55.4637 103.561C55.489 103.105 55.3797 102.651 55.1494 102.256C54.9192 101.861 54.578 101.543 54.1683 101.34C53.7586 101.137 53.2983 101.059 52.8446 101.115C52.8446 101.115 51.5432 101.199 49.6403 101.352C50.5676 103.515 50.953 106.783 48.0728 110.576Z",
    fill: "url(#paint76_linear_32758_33488)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M6.80981 75.4465C6.70338 74.3757 6.60984 73.4258 6.53888 72.7179C2.9604 76.0819 1.3042 79.7119 0.572059 82.6776C2.27341 77.7655 5.16168 76.0448 6.80981 75.4465Z",
    fill: "url(#paint77_linear_32758_33488)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3268 89.1315C10.5027 88.6477 9.98824 89.0121 10.1866 89.9491L11.9605 98.3817C12.1589 99.317 12.9942 100.478 13.8183 100.962L22.8734 106.3C23.3042 106.532 23.7981 106.621 24.2828 106.552C24.7675 106.483 25.2174 106.261 25.5665 105.918L29.4594 101.796C30.1158 101.101 29.9787 100.133 29.1546 99.646L11.3268 89.1315Z",
    fill: "white"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7623 88.9557C10.9367 88.4719 10.4238 88.8363 10.6222 89.7733L12.3961 98.2059C12.5929 99.1412 13.4298 100.302 14.2539 100.786L23.3089 106.124C23.7397 106.357 24.2337 106.445 24.7184 106.376C25.2031 106.307 25.653 106.085 26.0021 105.742L29.8934 101.62C30.5514 100.925 30.4143 99.9572 29.5902 99.4702L11.7623 88.9557Z",
    fill: "#3E3E3E"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3525 98.001L12.396 98.2074C12.4239 98.3343 12.46 98.4593 12.5041 98.5816L25.8101 105.924C25.8778 105.87 25.9419 105.812 26.002 105.75L26.1375 105.606L12.3525 98.001Z",
    fill: "#2B2B2B"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1534 104.531L27.4614 104.205L11.8445 95.5868L11.9638 96.1496L27.1534 104.531Z",
    fill: "#2B2B2B"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4558 93.7354L28.4774 103.129L28.7854 102.802L11.3365 93.1742L11.4558 93.7354Z",
    fill: "#2B2B2B"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8206 90.7602L10.9399 91.323L29.8015 101.726L29.8935 101.628C29.9643 101.553 30.028 101.471 30.0837 101.384L10.8206 90.7602Z",
    fill: "#2B2B2B"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M117.216 37.8731L126.44 57.5365L124.076 58.6453L114.853 38.9818L117.216 37.8731Z",
    fill: "url(#paint78_linear_32758_33488)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M157.593 32.7239C157.593 32.7239 111.037 68.6248 79.6388 87.0203C78.1471 87.975 77.4907 86.7494 77.8649 85.677C81.0499 76.3962 92.2385 47.3668 116.552 36.1508C140.546 25.0815 152.895 29.0986 157.317 30.6565C157.52 30.7287 157.699 30.8556 157.835 31.0231C157.971 31.1906 158.058 31.3923 158.086 31.606C158.115 31.8197 158.084 32.0371 157.997 32.2343C157.91 32.4315 157.77 32.6009 157.593 32.7239Z",
    fill: "#BBBBBB"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M9.53508 104.345L25.3633 113.484V109.859L9.53508 100.72V104.345Z",
    fill: "url(#paint79_linear_32758_33488)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45.2844 115.242C37.0776 117.196 11.6767 103.05 0.109161 90.944V102.405C0.109161 105.755 13.42 117.454 27.384 124.894C41.348 132.333 52.1802 128.94 56.2263 127.635C56.2263 117.682 58.5663 111.347 61.8706 107.222C54.7072 111.339 48.6065 114.455 45.2844 115.242ZM163.11 56.6429L165.851 52.9886V39.5278C155.637 46.6122 115.804 74.1885 107.289 79.0813C102.085 82.068 88.0053 91.352 74.3041 99.7894C81.8723 97.9865 78.281 111.455 78.281 111.455C78.281 111.455 135.317 76.3495 140.01 73.9999C140.794 70.9987 141.968 61.6018 152.669 53.9255C163.371 46.2493 163.11 56.6429 163.11 56.6429Z",
    fill: "#3E3E3E"
  }))), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M1.39624 95.9287C0.961985 95.0468 0.592762 94.1343 0.291556 93.1985L0.109326 93.0888V99.2169C0.394765 99.6362 0.699558 100.068 1.01725 100.507C1.03411 98.9738 1.16078 97.4438 1.39624 95.9287Z",
    fill: "url(#paint80_linear_32758_33488)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1484 121.091C37.797 121.235 35.7005 121.135 32.7639 120.285C32.5655 121.138 32.4784 122.233 32.9252 123.187C35.3667 123.941 37.3874 124.405 38.8226 124.703C43.3219 125.64 42.7978 120.699 39.1484 121.091Z",
    fill: "url(#paint81_linear_32758_33488)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M89.6923 97.2833L90.5712 96.6528L91.4533 96.0287L93.2272 94.7805C94.4098 93.9548 95.5924 93.1334 96.7751 92.3163C97.9587 91.4955 99.1537 90.6892 100.344 89.8748L103.927 87.4558L107.525 85.0578L108.428 84.4627L108.654 84.3127L108.709 84.2789L108.767 84.2369L108.878 84.1579C109.03 84.0515 109.181 83.9515 109.334 83.8515C109.948 83.4531 110.595 83.1099 111.27 82.8259C111.611 82.6839 111.962 82.5685 112.321 82.4808C112.686 82.3876 113.062 82.3474 113.439 82.3614C113.827 82.3744 114.205 82.4925 114.532 82.7033C114.848 82.9254 115.095 83.2315 115.246 83.587C115.389 83.9298 115.48 84.2917 115.517 84.6611C115.557 85.0236 115.57 85.3885 115.556 85.7528C115.543 86.4689 115.572 87.2042 115.443 87.9122C115.479 87.5537 115.488 87.1932 115.472 86.8333L115.432 85.7528C115.427 85.3958 115.397 85.0396 115.342 84.6869C115.29 84.3399 115.187 84.0025 115.037 83.6854C114.899 83.375 114.673 83.1126 114.385 82.9319C114.098 82.7512 113.763 82.6604 113.424 82.6711C113.079 82.6701 112.735 82.7168 112.402 82.8097C112.063 82.9029 111.731 83.0215 111.41 83.1645C110.764 83.4582 110.142 83.8039 109.552 84.1982C109.405 84.2966 109.259 84.3966 109.115 84.5014L109.009 84.5788L108.957 84.6175L108.897 84.6595L108.673 84.811L107.78 85.4206L104.193 87.8396L100.595 90.2457C99.3908 91.0375 98.191 91.8374 96.9799 92.6227C95.7688 93.4081 94.5609 94.1951 93.3482 94.9756L91.5226 96.1351L90.6099 96.7157L89.6923 97.2833Z",
    fill: "#3E3E3E"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5111 108.854C83.8012 102.887 83.8867 93.8 70.4469 98.667C54.0445 104.608 53.6914 122.931 53.9575 128.322C54.8589 128.077 55.6185 127.838 56.2265 127.638C56.2265 107.017 66.2749 101.928 74.1044 99.8394C81.9338 97.751 78.2811 111.45 78.2811 111.45L82.5111 108.854Z",
    fill: "url(#paint82_linear_32758_33488)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M137.694 75.2964C138.809 74.6513 139.605 74.203 140.01 74.0063C140.794 71.0051 141.968 61.6082 152.67 53.9319C163.371 46.2557 163.11 56.6493 163.11 56.6493L165.579 53.3578C164.585 47.9877 160.859 46.0622 150.842 51.829C141.508 57.1959 138.496 70.502 137.694 75.2964Z",
    fill: "url(#paint83_linear_32758_33488)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M82.2368 82.2599C82.2368 82.2599 91.895 89.0976 91.8514 85.7223C91.8079 82.347 85.5427 79.1668 84.4993 78.825C83.4559 78.4831 82.4545 80.3844 82.4545 80.3844L81.7578 80.0619V82.0212L82.2368 82.2599Z",
    fill: "#636363"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M164.972 59.7116C164.972 65.601 160.199 73.1305 154.31 76.5316C149.644 79.2248 145.679 78.5168 144.232 75.1786C144.644 75.1237 145.025 74.9324 145.316 74.6351C145.664 74.2527 145.868 73.7603 145.891 73.2434C145.911 73.0338 145.935 72.8241 145.961 72.6161C146.185 71.0921 146.511 69.5875 146.682 68.0539L146.653 68.27C146.704 67.8394 146.732 67.4088 146.775 66.9799C146.822 66.757 146.886 66.5381 146.967 66.3251C147.309 65.5849 147.736 64.8866 148.065 64.1416C148.322 63.5594 148.591 62.9869 148.883 62.4257C148.955 62.3451 149.021 62.2594 149.081 62.1693C149.383 61.7242 149.66 61.263 149.973 60.826C150.122 60.6491 150.284 60.4831 150.457 60.3293C150.747 60.1342 151.06 59.9697 151.362 59.7907C151.781 59.5391 152.195 59.28 152.605 59.0134C153.411 58.4893 154.206 57.9409 154.995 57.3862C155.159 57.2729 155.312 57.1432 155.45 56.9992L155.572 56.9395C156.701 56.5057 157.891 56.2783 159.065 55.9977C159.755 55.8364 160.439 55.6881 161.142 55.58C161.87 55.4896 162.587 55.3303 163.284 55.1043L163.411 55.0559C164.402 56.1009 164.972 57.67 164.972 59.7116ZM161.249 61.8629C161.274 61.0343 161.087 60.213 160.704 59.4778C160.376 58.8719 159.851 58.3962 159.215 58.1296C158.514 57.854 157.75 57.7802 157.009 57.9168C156.054 58.0851 155.139 58.429 154.31 58.9311C153.322 59.5092 152.413 60.214 151.608 61.0276C150.774 61.8677 150.034 62.7968 149.402 63.7981C148.787 64.757 148.288 65.7855 147.915 66.8621C147.57 67.8309 147.386 68.8496 147.37 69.8778C147.345 70.7064 147.532 71.5277 147.915 72.2629C148.244 72.868 148.768 73.3434 149.402 73.6111C150.103 73.8851 150.866 73.9577 151.605 73.8208C152.561 73.6528 153.476 73.3088 154.306 72.8064C155.294 72.2287 156.202 71.5239 157.006 70.7099C157.841 69.8732 158.581 68.9467 159.212 67.9475C159.828 66.9886 160.327 65.9601 160.7 64.8834C161.047 63.9133 161.232 62.8929 161.249 61.8629Z",
    fill: "url(#paint84_linear_32758_33488)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M155.732 58.8409C154.458 59.5889 153.288 60.5003 152.25 61.5518C151.713 62.0903 151.205 62.6583 150.731 63.2531C150.256 63.8486 149.813 64.4693 149.405 65.1125C149.005 65.7437 148.64 66.3968 148.312 67.0687C147.997 67.7156 147.722 68.3812 147.488 69.0619C147.044 70.3107 146.807 71.6234 146.786 72.9484C146.786 74.1563 147.024 75.1916 147.488 76.0221C147.704 76.4123 147.983 76.7647 148.312 77.0655C148.635 77.356 149.005 77.5904 149.405 77.759C149.829 77.9322 150.275 78.0409 150.731 78.0815C151.238 78.1274 151.748 78.1095 152.25 78.0283C153.481 77.8104 154.661 77.367 155.73 76.7204C157.004 75.9725 158.174 75.0612 159.21 74.0095C159.747 73.4716 160.254 72.9041 160.728 72.3098C161.203 71.7144 161.645 71.0936 162.053 70.4504C162.454 69.819 162.819 69.166 163.147 68.4943C163.462 67.847 163.738 67.1807 163.971 66.4994C164.413 65.2532 164.648 63.9431 164.668 62.621C164.668 61.4131 164.432 60.3778 163.966 59.5456C163.75 59.156 163.471 58.8041 163.142 58.5039C162.819 58.2134 162.449 57.979 162.049 57.8104C161.625 57.6372 161.179 57.5285 160.723 57.4879C160.217 57.442 159.707 57.4599 159.206 57.5411C157.975 57.7585 156.795 58.2014 155.725 58.8474L155.732 58.8409ZM155.732 55.9381C162.273 52.1613 167.575 54.4029 167.575 60.9374C167.575 67.4718 162.273 75.8447 155.732 79.6216C149.191 83.3984 143.887 81.1568 143.887 74.6223C143.887 68.0879 149.186 59.7166 155.732 55.9397V55.9381Z",
    fill: "#3E3E3E"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M152.573 76.3028C152.133 76.3646 151.687 76.3646 151.247 76.3028C150.797 76.2406 150.358 76.118 149.941 75.9383C149.941 75.9383 153.005 74.6708 153.676 73.3452C154.347 72.0196 155.127 69.8941 155.127 69.8941L157.033 70.1554C156.306 71.2438 155.637 72.3705 155.031 73.5306C154.195 75.1691 152.573 76.3028 152.573 76.3028Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M148.256 71.168C148.32 69.9925 148.617 68.8414 149.13 67.7815C149.13 67.7815 151.981 68.8877 153.087 68.5797C154.194 68.2717 156.029 67.4057 156.029 67.4057L155.36 70.0376C154.433 70.0739 153.514 70.2118 152.618 70.4488C151.246 70.831 148.256 71.168 148.256 71.168Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M153.758 61.5743C154.231 61.1766 154.733 60.8154 155.261 60.4938C155.74 60.1865 156.247 59.9246 156.775 59.7117C156.775 59.7117 157.412 62.7403 157.458 63.8659C157.503 64.9915 157.916 66.5558 157.916 66.5558L155.576 68.0072C155.737 66.9767 155.811 65.9345 155.798 64.8916C155.74 63.5014 153.758 61.5743 153.758 61.5743Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M161.805 59.815C162.094 60.0862 162.328 60.4103 162.494 60.7697C162.691 61.1569 162.827 61.5718 162.899 62.0001C162.899 62.0001 162.202 63.9805 161.125 65.019C160.048 66.0576 158.478 67.9363 158.478 67.9363L157.632 66.243C158.642 65.4938 159.607 64.6861 160.523 63.8241C161.854 62.5323 161.805 59.815 161.805 59.815ZM161.249 70.1892C161.249 70.1892 160.62 70.3311 159.872 71.2955C159.422 71.8776 159.009 72.4873 158.635 73.121C158.635 73.121 159.294 72.0663 158.624 71.5084C157.953 70.9504 156.622 70.444 156.622 70.444L158.527 67.9912C158.527 67.9912 159.149 69.0862 159.978 69.7651C160.807 70.444 161.249 70.1892 161.249 70.1892ZM149.401 65.7705C149.239 66.3382 149.078 66.9091 148.93 67.4864C149.254 66.7507 149.631 66.0398 150.059 65.3593C149.853 65.5164 149.632 65.6541 149.401 65.7705Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M163.745 59.3877C163.146 59.5003 162.53 59.4849 161.937 59.3426C161.467 59.2118 161.014 59.0222 160.591 58.7781C160.07 58.7959 159.549 58.8604 159.023 58.8684C158.398 58.8781 157.777 58.8039 157.154 58.8007C156.401 59.1716 155.669 59.5167 154.85 59.6699C154.765 60.0133 154.637 60.3445 154.468 60.6553C154.768 60.4456 155.071 60.2489 155.377 60.0731C156.272 59.5324 157.259 59.1617 158.288 58.9797C159.086 58.8335 159.91 58.9134 160.665 59.2103C161.349 59.498 161.914 60.0099 162.268 60.6617C162.657 61.3568 162.853 62.2228 162.853 63.2323C162.836 64.3401 162.639 65.4376 162.268 66.4818C161.865 67.6414 161.327 68.7494 160.665 69.7829C159.984 70.8589 159.187 71.8567 158.288 72.7582C157.421 73.6377 156.442 74.3999 155.377 75.0256C154.485 75.5644 153.501 75.935 152.474 76.119C151.674 76.268 150.849 76.1897 150.091 75.8932C149.407 75.6055 148.842 75.0936 148.488 74.4418C148.099 73.7452 147.901 72.8808 147.901 71.8616C147.902 71.4465 147.934 71.032 147.996 70.6215C147.88 71.0198 147.773 71.4278 147.691 71.8342C147.659 72.304 147.659 72.7755 147.691 73.2453C147.801 73.7991 147.952 74.344 148.143 74.8757C148.251 75.0928 148.371 75.3043 148.501 75.5094C148.902 76.1332 149.101 76.8651 149.072 77.6059C150.696 78.2671 152.924 77.9655 155.384 76.5464C160.357 73.6758 164.389 67.3171 164.389 62.3437C164.382 61.1729 164.155 60.1795 163.745 59.3877Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M155.732 60.3083C154.67 60.931 153.694 61.69 152.829 62.5661C151.93 63.468 151.133 64.4657 150.452 65.5414C149.789 66.5753 149.251 67.6839 148.849 68.8441C148.479 69.8882 148.281 70.9858 148.264 72.0936C148.264 73.1031 148.46 73.9675 148.849 74.6642C149.203 75.316 149.768 75.8279 150.452 76.1156C151.207 76.4125 152.031 76.4924 152.829 76.3462C153.856 76.1632 154.84 75.7926 155.732 75.2528C156.794 74.6262 157.77 73.864 158.635 72.9854C159.534 72.0842 160.331 71.0864 161.012 70.0101C161.674 68.9766 162.212 67.8685 162.615 66.709C162.986 65.6704 163.187 64.5784 163.208 63.4756C163.208 62.4661 163.01 61.6017 162.621 60.905C162.267 60.2532 161.702 59.7414 161.018 59.4536C160.263 59.1567 159.439 59.0769 158.641 59.223C157.614 59.4055 156.63 59.7762 155.738 60.3164L155.732 60.3083ZM155.732 58.7812C160.704 55.909 164.735 57.6136 164.735 62.5854C164.735 67.5572 160.704 73.9175 155.732 76.7881C150.76 79.6586 146.727 77.9556 146.727 72.9822C146.727 68.0088 150.758 61.6517 155.732 58.7812Z",
    fill: "url(#paint85_linear_32758_33488)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M161.249 69.6361C160.933 70.2248 160.566 70.7845 160.152 71.3084C159.736 71.8538 159.281 72.3679 158.789 72.8468C158.789 72.8468 159.454 72.0131 158.862 71.5148C158.198 70.9552 156.861 70.4504 156.861 70.4504L158.762 67.9911C158.762 67.9911 159.385 69.0861 160.213 69.7651C161.042 70.444 161.249 69.6361 161.249 69.6361Z",
    fill: "url(#paint86_linear_32758_33488)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M152.705 76.4204C152.265 76.4822 151.819 76.4822 151.379 76.4204C150.964 76.3734 150.564 76.234 150.209 76.0124C150.209 76.0124 153.139 74.7884 153.81 73.4628C154.48 72.1372 155.261 70.0117 155.261 70.0117L157.166 70.273C156.438 71.3612 155.77 72.488 155.164 73.6483C154.334 75.2867 152.705 76.4204 152.705 76.4204Z",
    fill: "url(#paint87_linear_32758_33488)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M148.256 71.3777C148.32 70.2021 148.617 69.051 149.13 67.9911C149.13 67.9911 151.981 69.0974 153.087 68.7974C154.194 68.4975 156.029 67.6234 156.029 67.6234L155.36 70.2488C154.433 70.2862 153.514 70.4247 152.618 70.6617C151.246 71.0374 148.256 71.3777 148.256 71.3777Z",
    fill: "url(#paint88_linear_32758_33488)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M153.968 61.5161C154.441 61.1189 154.943 60.7577 155.471 60.4357C155.951 60.1285 156.458 59.8666 156.987 59.6535C156.987 59.6535 157.624 62.6821 157.669 63.8093C157.714 64.9366 158.127 66.4993 158.127 66.4993L155.787 67.9506C155.947 66.9228 156.021 65.8833 156.008 64.8431C155.95 63.4433 153.968 61.5161 153.968 61.5161Z",
    fill: "url(#paint89_linear_32758_33488)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M162.041 60.0504C162.33 60.3212 162.564 60.6454 162.729 61.0051C162.926 61.3923 163.062 61.8072 163.134 62.2356C163.134 62.2356 162.437 64.2159 161.36 65.2545C160.283 66.293 158.715 68.1734 158.715 68.1734L157.867 66.4785C158.878 65.7298 159.843 64.922 160.759 64.0595C162.087 62.7694 162.041 60.0504 162.041 60.0504Z",
    fill: "url(#paint90_linear_32758_33488)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M159.249 66.9363C159.249 68.3232 158.12 70.0971 156.738 70.897C155.356 71.6969 154.226 71.2195 154.226 69.8359C154.226 68.4522 155.355 66.6751 156.738 65.8752C158.122 65.0753 159.249 65.5494 159.249 66.9363Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M159.485 67.1719C159.485 68.5588 158.356 70.3327 156.974 71.1326C155.592 71.9325 154.463 71.4552 154.463 70.0715C154.463 68.6878 155.592 66.9107 156.974 66.1108C158.356 65.3109 159.485 65.7851 159.485 67.1719Z",
    fill: "url(#paint91_linear_32758_33488)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M157.032 69.9796C157.757 69.5603 158.346 68.6266 158.346 67.8977C158.359 67.7518 158.332 67.6053 158.267 67.4738C158.203 67.3422 158.104 67.2306 157.982 67.151C157.706 66.9897 157.317 67.0333 156.914 67.2655C156.19 67.6832 155.601 68.6169 155.601 69.3458C155.589 69.4902 155.615 69.6353 155.678 69.7659C155.741 69.8964 155.838 70.0076 155.959 70.0876C156.075 70.1533 156.207 70.1867 156.34 70.1844C156.584 70.1777 156.823 70.1071 157.032 69.9796ZM157.864 67.3542C157.95 67.4146 158.018 67.4968 158.061 67.5923C158.105 67.6879 158.122 67.7933 158.111 67.8977C158.111 68.5524 157.574 69.3942 156.914 69.7748C156.591 69.9635 156.285 70.0054 156.084 69.8893C155.998 69.8289 155.93 69.7467 155.886 69.6511C155.843 69.5556 155.826 69.4502 155.837 69.3458C155.837 68.7008 156.374 67.8493 157.032 67.4687C157.203 67.3618 157.398 67.3002 157.599 67.2897C157.692 67.2874 157.783 67.3097 157.864 67.3542Z",
    fill: "url(#paint92_linear_32758_33488)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M143.887 74.6223C143.887 68.0814 149.189 59.7165 155.732 55.9397C157.885 54.6963 159.906 54.1045 161.646 54.1045C162.573 54.0909 163.491 54.286 164.332 54.6754L162.478 53.5852C162.201 53.5559 161.924 53.5414 161.646 53.5417C159.756 53.5417 157.614 54.2012 155.45 55.451C152.208 57.3233 149.16 60.339 146.88 63.9433C144.6 67.5476 143.323 71.3615 143.323 74.6223C143.323 76.5429 143.768 78.1895 144.613 79.4393L146.521 80.552C144.876 79.4683 143.887 77.446 143.887 74.6223Z",
    fill: "#516882"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2388 112.263C80.2388 118.153 75.4653 125.682 69.5759 129.083C64.9105 131.776 60.945 131.068 59.5 127.73C59.9114 127.675 60.2925 127.484 60.5821 127.187C60.9304 126.804 61.1346 126.312 61.1595 125.795C61.1772 125.585 61.2014 125.376 61.2272 125.168C61.4513 123.644 61.7771 122.139 61.948 120.606L61.919 120.822C61.9706 120.391 61.998 119.96 62.0416 119.532C62.0891 119.309 62.1538 119.09 62.2351 118.877C62.577 118.137 63.0027 117.438 63.3317 116.693C63.5881 116.111 63.859 115.539 64.1509 114.977C64.2226 114.896 64.2889 114.811 64.3493 114.721C64.6492 114.276 64.9266 113.815 65.2411 113.378C65.3898 113.2 65.5515 113.034 65.7249 112.881C66.0168 112.686 66.328 112.521 66.6296 112.342C67.0489 112.091 67.4639 111.832 67.8745 111.565C68.6809 111.041 69.4743 110.493 70.2629 109.938C70.4275 109.825 70.5799 109.695 70.7177 109.551L70.8418 109.491C71.9707 109.057 73.1608 108.83 74.3332 108.549C75.0234 108.388 75.7072 108.24 76.4103 108.132C77.1375 108.044 77.8546 107.886 78.5519 107.662L78.6793 107.614C79.6679 108.653 80.2388 110.227 80.2388 112.263ZM76.5151 114.413C76.5151 113.476 76.3329 112.673 75.9701 112.028C75.6428 111.422 75.1182 110.946 74.4832 110.68C73.7823 110.403 73.0179 110.33 72.2771 110.467C71.3217 110.635 70.4059 110.979 69.5759 111.481C68.5885 112.059 67.6809 112.764 66.8763 113.578C66.0419 114.415 65.3021 115.341 64.6702 116.34C64.0545 117.299 63.5548 118.327 63.1817 119.404C62.8368 120.373 62.6527 121.392 62.6367 122.42C62.611 123.248 62.7987 124.07 63.1817 124.805C63.5106 125.41 64.0355 125.886 64.6702 126.153C65.3709 126.43 66.1352 126.505 66.8763 126.369C67.8312 126.201 68.7466 125.857 69.5759 125.355C70.5641 124.777 71.4723 124.072 72.2771 123.258C73.111 122.421 73.8508 121.494 74.4832 120.496C75.0984 119.537 75.5975 118.508 75.9701 117.432C76.316 116.462 76.5002 115.442 76.5151 114.413Z",
    fill: "url(#paint93_linear_32758_33488)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9983 111.393C69.7257 112.141 68.5558 113.053 67.5182 114.103C66.9812 114.642 66.4746 115.21 66.0007 115.805C65.5251 116.4 65.0826 117.021 64.6751 117.664C64.2733 118.295 63.9082 118.948 63.5817 119.62C63.2651 120.267 62.9898 120.932 62.7577 121.614C62.3134 122.862 62.0764 124.175 62.0561 125.5C62.0561 126.708 62.2916 127.743 62.7577 128.574C62.9729 128.965 63.2513 129.317 63.5817 129.617C63.9045 129.908 64.2741 130.143 64.6751 130.311C65.0983 130.484 65.5451 130.593 66.0007 130.633C66.5068 130.679 67.0166 130.661 67.5182 130.58C68.7491 130.363 69.929 129.919 70.9983 129.272C72.2717 128.524 73.4417 127.613 74.4784 126.561C75.0155 126.023 75.5221 125.456 75.9959 124.861C76.4715 124.266 76.914 123.646 77.3215 123.002C77.7229 122.372 78.088 121.719 78.4149 121.048C78.7319 120.401 79.0071 119.735 79.239 119.053C79.6834 117.805 79.9204 116.492 79.9405 115.168C79.9405 113.96 79.705 112.925 79.239 112.092C79.0238 111.702 78.7453 111.35 78.4149 111.051C78.0922 110.759 77.7225 110.525 77.3215 110.357C76.8984 110.184 76.4515 110.075 75.9959 110.035C75.4899 109.989 74.98 110.007 74.4784 110.088C73.2478 110.305 72.068 110.748 70.9983 111.394V111.393ZM70.9983 108.49C77.5392 104.713 82.8433 106.955 82.8433 113.489C82.8433 120.023 77.5392 128.404 70.9983 132.175C64.4574 135.945 59.1534 133.71 59.1534 127.176C59.1534 120.641 64.4574 112.27 70.9983 108.493V108.49Z",
    fill: "#3E3E3E"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9984 112.86C69.9366 113.483 68.9608 114.242 68.0956 115.118C67.1968 116.02 66.3997 117.017 65.7185 118.093C65.0553 119.127 64.5172 120.235 64.1155 121.396C63.7437 122.44 63.5454 123.537 63.5285 124.645C63.5285 125.655 63.7253 126.519 64.1155 127.216C64.4691 127.868 65.0346 128.38 65.7185 128.667C66.4739 128.964 67.2972 129.044 68.0956 128.898C69.1223 128.715 70.1064 128.345 70.9984 127.804C72.0603 127.178 73.036 126.416 73.9011 125.537C74.8007 124.636 75.5979 123.638 76.2782 122.562C76.9424 121.533 77.4826 120.429 77.8876 119.274C78.2595 118.23 78.4578 117.132 78.4746 116.024C78.4746 115.015 78.2779 114.15 77.8876 113.453C77.534 112.801 76.9686 112.289 76.2846 112.002C75.5293 111.705 74.7059 111.625 73.9076 111.771C72.8809 111.954 71.8968 112.325 71.0048 112.865L70.9984 112.86ZM70.9984 111.333C75.9718 108.469 80.0034 110.165 80.0034 115.137C80.0034 120.109 75.9718 126.469 71 129.34C66.0282 132.21 61.9965 130.507 61.9965 125.534C61.9965 120.56 66.0282 114.203 71 111.333H70.9984Z",
    fill: "url(#paint94_linear_32758_33488)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5151 122.187C76.1714 122.765 75.7906 123.319 75.375 123.847C74.97 124.38 74.5298 124.886 74.0575 125.361C74.0575 125.361 74.796 124.618 74.1268 124.071C73.4575 123.524 72.1239 123.007 72.1239 123.007L74.0365 120.541C74.0365 120.541 74.6574 121.636 75.4879 122.315C76.3184 122.994 76.5151 122.187 76.5151 122.187Z",
    fill: "url(#paint95_linear_32758_33488)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M68.0116 128.851C67.5748 128.916 67.1308 128.916 66.6941 128.851C66.2961 128.81 65.9097 128.694 65.5555 128.508C65.5555 128.508 68.4051 127.334 69.076 126.008C69.7468 124.682 70.5273 122.557 70.5273 122.557L72.4238 122.821C71.6987 123.914 71.0327 125.044 70.429 126.208C69.6001 127.838 68.0116 128.851 68.0116 128.851Z",
    fill: "url(#paint96_linear_32758_33488)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5219 123.926C63.5861 122.75 63.8838 121.599 64.3976 120.539C64.3976 120.539 67.2488 121.646 68.3534 121.338C69.4581 121.03 71.2949 120.165 71.2949 120.165L70.6241 122.796C69.6979 122.833 68.7786 122.971 67.8825 123.208C66.5118 123.589 63.5219 123.926 63.5219 123.926Z",
    fill: "url(#paint97_linear_32758_33488)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2358 114.068C69.7087 113.67 70.2111 113.309 70.7388 112.987C71.2181 112.68 71.725 112.418 72.2531 112.205C72.2531 112.205 72.8901 115.234 72.9352 116.361C72.9804 117.488 73.3916 119.049 73.3916 119.049L71.0516 120.501C71.2121 119.473 71.286 118.433 71.2726 117.393C71.2177 115.995 69.2358 114.068 69.2358 114.068Z",
    fill: "url(#paint98_linear_32758_33488)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3086 112.602C77.5972 112.873 77.831 113.197 77.9972 113.557C78.1939 113.944 78.3299 114.359 78.4004 114.787C78.4004 114.787 77.7053 116.768 76.6265 117.806C75.5476 118.845 73.9833 120.725 73.9833 120.725L73.1367 119.03C74.1473 118.281 75.1128 117.474 76.0282 116.611C77.357 115.321 77.3086 112.602 77.3086 112.602Z",
    fill: "url(#paint99_linear_32758_33488)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7524 119.723C74.7524 121.11 73.6236 122.884 72.2399 123.684C70.8563 124.484 69.729 124.007 69.729 122.623C69.729 121.239 70.8579 119.462 72.2399 118.662C73.622 117.862 74.7524 118.336 74.7524 119.723Z",
    fill: "url(#paint100_linear_32758_33488)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M72.3578 122.633C73.1287 122.188 73.7318 121.23 73.7318 120.449C73.7443 120.282 73.7115 120.115 73.6368 119.966C73.5621 119.816 73.4484 119.69 73.3077 119.599C72.9851 119.419 72.5626 119.461 72.1224 119.714C71.3531 120.159 70.75 121.118 70.75 121.897C70.7371 122.064 70.7698 122.231 70.8445 122.381C70.9192 122.531 71.0331 122.657 71.1741 122.747C71.3079 122.822 71.4593 122.861 71.6128 122.858C71.8766 122.85 72.1335 122.772 72.3578 122.633ZM73.069 120.009C73.1356 120.06 73.1879 120.127 73.2207 120.204C73.2535 120.281 73.2657 120.366 73.256 120.449C73.256 121.055 72.7368 121.868 72.1272 122.223C71.8417 122.384 71.5757 122.429 71.4144 122.338C71.3472 122.287 71.2944 122.219 71.2613 122.142C71.2282 122.064 71.216 121.979 71.2257 121.896C71.2257 121.289 71.7466 120.477 72.3626 120.122C72.5163 120.026 72.6916 119.971 72.8722 119.96C72.9409 119.959 73.0087 119.976 73.069 120.009Z",
    fill: "url(#paint101_linear_32758_33488)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M59.1535 127.176C59.1535 120.635 64.4575 112.27 70.9984 108.493C73.1529 107.25 75.172 106.658 76.912 106.658C77.8396 106.644 78.7583 106.839 79.6003 107.229L77.7458 106.137C77.4694 106.107 77.1916 106.093 76.9137 106.093C75.0252 106.093 72.882 106.753 70.7178 108.003C67.4764 109.875 64.4285 112.891 62.1482 116.495C59.8679 120.099 58.6004 123.913 58.6004 127.174C58.6004 129.095 59.0438 130.741 59.8905 131.991L61.7982 133.104C60.1421 132.013 59.1535 129.998 59.1535 127.176Z",
    fill: "#E4E4E4"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M80.2388 112.263C80.2388 118.153 75.4653 125.682 69.5759 129.083C64.9105 131.776 60.945 131.068 59.5 127.73C59.9114 127.675 60.2925 127.484 60.5821 127.187C60.9304 126.804 61.1346 126.312 61.1595 125.795C61.1772 125.585 61.2014 125.376 61.2272 125.168C61.4513 123.644 61.7771 122.139 61.948 120.606L61.919 120.822C61.9706 120.391 61.998 119.96 62.0416 119.532C62.0891 119.309 62.1538 119.09 62.2351 118.877C62.577 118.137 63.0027 117.438 63.3317 116.693C63.5881 116.111 63.859 115.539 64.1509 114.977C64.2226 114.896 64.2889 114.811 64.3493 114.721C64.6492 114.276 64.9266 113.815 65.2411 113.378C65.3898 113.2 65.5515 113.034 65.7249 112.881C66.0168 112.686 66.328 112.521 66.6296 112.342C67.0489 112.091 67.4639 111.832 67.8745 111.565C68.6809 111.041 69.4743 110.493 70.2629 109.938C70.4275 109.825 70.5799 109.695 70.7177 109.551L70.8418 109.491C71.9707 109.057 73.1608 108.83 74.3332 108.549C75.0234 108.388 75.7072 108.24 76.4103 108.132C77.1375 108.044 77.8546 107.886 78.5519 107.662L78.6793 107.614C79.6679 108.653 80.2388 110.227 80.2388 112.263ZM76.5151 114.413C76.5151 113.476 76.3329 112.673 75.9701 112.028C75.6428 111.422 75.1182 110.946 74.4832 110.68C73.7823 110.403 73.0179 110.33 72.2771 110.467C71.3217 110.635 70.4059 110.979 69.5759 111.481C68.5885 112.059 67.6809 112.764 66.8763 113.578C66.0419 114.415 65.3021 115.341 64.6702 116.34C64.0545 117.299 63.5548 118.327 63.1817 119.404C62.8368 120.373 62.6527 121.392 62.6367 122.42C62.611 123.248 62.7987 124.07 63.1817 124.805C63.5106 125.41 64.0355 125.886 64.6702 126.153C65.3709 126.43 66.1352 126.505 66.8763 126.369C67.8312 126.201 68.7466 125.857 69.5759 125.355C70.5641 124.777 71.4723 124.072 72.2771 123.258C73.111 122.421 73.8508 121.494 74.4832 120.496C75.0984 119.537 75.5975 118.508 75.9701 117.432C76.316 116.462 76.5002 115.442 76.5151 114.413Z",
    fill: "url(#paint102_linear_32758_33488)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9983 111.393C69.7257 112.141 68.5558 113.053 67.5182 114.103C66.9812 114.642 66.4746 115.21 66.0007 115.805C65.5251 116.4 65.0826 117.021 64.6751 117.664C64.2733 118.295 63.9082 118.948 63.5817 119.62C63.2651 120.267 62.9898 120.932 62.7577 121.614C62.3134 122.862 62.0764 124.175 62.0561 125.5C62.0561 126.708 62.2916 127.743 62.7577 128.574C62.9729 128.965 63.2513 129.317 63.5817 129.617C63.9045 129.908 64.2741 130.143 64.6751 130.311C65.0983 130.484 65.5451 130.593 66.0007 130.633C66.5068 130.679 67.0166 130.661 67.5182 130.58C68.7491 130.363 69.929 129.919 70.9983 129.272C72.2717 128.524 73.4417 127.613 74.4784 126.561C75.0155 126.023 75.5221 125.456 75.9959 124.861C76.4715 124.266 76.914 123.646 77.3215 123.002C77.7229 122.372 78.088 121.719 78.4149 121.048C78.7319 120.401 79.0071 119.735 79.239 119.053C79.6834 117.805 79.9204 116.492 79.9405 115.168C79.9405 113.96 79.705 112.925 79.239 112.092C79.0238 111.702 78.7453 111.35 78.4149 111.051C78.0922 110.759 77.7225 110.525 77.3215 110.357C76.8984 110.184 76.4515 110.075 75.9959 110.035C75.4899 109.989 74.98 110.007 74.4784 110.088C73.2478 110.305 72.068 110.748 70.9983 111.394V111.393ZM70.9983 108.49C77.5392 104.713 82.8433 106.955 82.8433 113.489C82.8433 120.023 77.5392 128.404 70.9983 132.175C64.4574 135.945 59.1534 133.71 59.1534 127.176C59.1534 120.641 64.4574 112.27 70.9983 108.493V108.49Z",
    fill: "#3E3E3E"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8342 128.854C67.3945 128.916 66.9483 128.916 66.5086 128.854C66.0588 128.792 65.6194 128.669 65.2024 128.49C65.2024 128.49 68.2664 127.222 68.9373 125.897C69.6081 124.571 70.3887 122.446 70.3887 122.446L72.2932 122.707C71.5658 123.795 70.8977 124.922 70.2919 126.082C69.463 127.721 67.8342 128.854 67.8342 128.854Z",
    fill: "white"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5219 123.72C63.5861 122.544 63.8838 121.393 64.3976 120.333C64.3976 120.333 67.2488 121.439 68.3534 121.131C69.4581 120.823 71.2949 119.959 71.2949 119.959L70.6241 122.591C69.6979 122.627 68.7786 122.765 67.8825 123.002C66.5118 123.383 63.5219 123.72 63.5219 123.72Z",
    fill: "white"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M69.0245 114.126C69.4974 113.728 69.9998 113.367 70.5275 113.045C71.007 112.738 71.5139 112.477 72.0417 112.263C72.0417 112.263 72.6868 115.292 72.7255 116.418C72.7642 117.543 73.1819 119.112 73.1819 119.112L70.8419 120.564C71.0032 119.535 71.0771 118.495 71.0629 117.454C71.0064 116.048 69.0245 114.126 69.0245 114.126Z",
    fill: "white"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M77.0733 112.366C77.3619 112.638 77.5956 112.962 77.7619 113.321C77.9585 113.708 78.0945 114.123 78.165 114.552C78.165 114.552 77.47 116.532 76.3911 117.57C75.3123 118.609 73.7464 120.488 73.7464 120.488L72.9078 118.79C73.9173 118.04 74.8822 117.232 75.7977 116.371C77.1217 115.081 77.0733 112.366 77.0733 112.366ZM76.5153 122.741C76.5153 122.741 75.8864 122.883 75.1397 123.847C74.6895 124.429 74.2759 125.039 73.9012 125.672C73.9012 125.672 74.5608 124.618 73.8899 124.06C73.219 123.502 71.8886 122.995 71.8886 122.995L73.7947 120.541C73.7947 120.541 74.4156 121.636 75.2461 122.315C76.0767 122.994 76.5153 122.741 76.5153 122.741ZM64.6671 118.322C64.5059 118.89 64.3446 119.461 64.1978 120.036C64.5213 119.301 64.8986 118.591 65.3267 117.911C65.1203 118.068 64.8995 118.206 64.6671 118.322Z",
    fill: "white"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0115 111.938C78.4126 112.051 77.7964 112.037 77.2037 111.894C76.7334 111.763 76.2815 111.573 75.8587 111.33C75.3362 111.347 74.8154 111.412 74.2896 111.42C73.6655 111.43 73.0447 111.355 72.4206 111.352C71.6674 111.723 70.9369 112.068 70.1177 112.221C70.0314 112.564 69.903 112.895 69.7355 113.207C70.0354 112.997 70.3386 112.8 70.645 112.625C71.5386 112.084 72.5244 111.714 73.5526 111.533C74.351 111.387 75.1743 111.466 75.9297 111.763C76.6136 112.051 77.1791 112.563 77.5327 113.215C77.9213 113.91 78.1197 114.776 78.1197 115.785C78.102 116.893 77.9037 117.99 77.5327 119.033C77.1316 120.194 76.5941 121.303 75.9313 122.338C75.2499 123.413 74.4522 124.409 73.5526 125.31C72.6876 126.188 71.7118 126.95 70.6499 127.577C69.7546 128.116 68.768 128.487 67.739 128.67C66.9412 128.817 66.1183 128.737 65.3636 128.44C64.6797 128.153 64.1142 127.641 63.7606 126.988C63.3703 126.292 63.1736 125.427 63.1736 124.408C63.1752 123.993 63.2064 123.579 63.2671 123.168C63.151 123.566 63.0446 123.974 62.9639 124.381C62.9309 124.851 62.9309 125.322 62.9639 125.792C63.0754 126.346 63.2269 126.89 63.4171 127.422C63.5252 127.639 63.6441 127.851 63.7735 128.056C64.175 128.679 64.3744 129.412 64.3444 130.152C65.9699 130.814 68.1986 130.512 70.6579 129.093C75.6297 126.222 79.6614 119.864 79.6614 114.89C79.6485 113.724 79.4227 112.731 79.0115 111.938Z",
    fill: "white"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9984 112.86C69.9366 113.483 68.9608 114.242 68.0956 115.118C67.1968 116.02 66.3997 117.017 65.7185 118.093C65.0553 119.127 64.5172 120.235 64.1155 121.396C63.7437 122.44 63.5454 123.537 63.5285 124.645C63.5285 125.655 63.7253 126.519 64.1155 127.216C64.4691 127.868 65.0346 128.38 65.7185 128.667C66.4739 128.964 67.2972 129.044 68.0956 128.898C69.1223 128.715 70.1064 128.345 70.9984 127.804C72.0603 127.178 73.036 126.416 73.9011 125.537C74.8007 124.636 75.5979 123.638 76.2782 122.562C76.9424 121.533 77.4826 120.429 77.8876 119.274C78.2595 118.23 78.4578 117.132 78.4746 116.024C78.4746 115.015 78.2779 114.15 77.8876 113.453C77.534 112.801 76.9686 112.289 76.2846 112.002C75.5293 111.705 74.7059 111.625 73.9076 111.771C72.8809 111.954 71.8968 112.325 71.0048 112.865L70.9984 112.86ZM70.9984 111.333C75.9718 108.469 80.0034 110.165 80.0034 115.137C80.0034 120.109 75.9718 126.469 71 129.34C66.0282 132.21 61.9965 130.507 61.9965 125.534C61.9965 120.56 66.0282 114.203 71 111.333H70.9984Z",
    fill: "url(#paint103_linear_32758_33488)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M76.5151 122.187C76.1988 122.776 75.8307 123.336 75.4153 123.86C74.9993 124.406 74.5439 124.921 74.0526 125.401C74.0526 125.401 74.7186 124.568 74.1268 124.069C73.4624 123.51 72.1239 123.005 72.1239 123.005L74.0365 120.541C74.0365 120.541 74.6574 121.636 75.4879 122.315C76.3184 122.994 76.5151 122.187 76.5151 122.187Z",
    fill: "url(#paint104_linear_32758_33488)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M67.9713 128.972C67.5316 129.034 67.0854 129.034 66.6457 128.972C66.2299 128.925 65.8299 128.785 65.4749 128.564C65.4749 128.564 68.4051 127.34 69.076 126.014C69.7468 124.689 70.5273 122.563 70.5273 122.563L72.4238 122.821C71.6987 123.913 71.0327 125.044 70.429 126.208C69.6001 127.838 67.9713 128.972 67.9713 128.972Z",
    fill: "url(#paint105_linear_32758_33488)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5219 123.926C63.5861 122.75 63.8838 121.599 64.3976 120.539C64.3976 120.539 67.2488 121.646 68.3534 121.338C69.4581 121.03 71.2949 120.165 71.2949 120.165L70.6241 122.796C69.6979 122.833 68.7786 122.971 67.8825 123.208C66.5118 123.589 63.5219 123.926 63.5219 123.926Z",
    fill: "url(#paint106_linear_32758_33488)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2358 114.068C69.7087 113.67 70.2111 113.309 70.7388 112.987C71.2181 112.68 71.725 112.418 72.2531 112.205C72.2531 112.205 72.8901 115.234 72.9352 116.361C72.9804 117.488 73.3916 119.049 73.3916 119.049L71.0516 120.501C71.2121 119.473 71.286 118.433 71.2726 117.393C71.2177 115.995 69.2358 114.068 69.2358 114.068Z",
    fill: "url(#paint107_linear_32758_33488)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M77.3086 112.602C77.5972 112.873 77.831 113.197 77.9972 113.557C78.1939 113.944 78.3299 114.359 78.4004 114.787C78.4004 114.787 77.7053 116.768 76.6265 117.806C75.5476 118.845 73.9833 120.725 73.9833 120.725L73.1367 119.03C74.1473 118.281 75.1128 117.474 76.0282 116.611C77.357 115.321 77.3086 112.602 77.3086 112.602Z",
    fill: "url(#paint108_linear_32758_33488)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M69.9956 123.598C69.1622 122.971 69.3853 121.268 70.4941 119.794C71.6029 118.32 73.1774 117.633 74.0109 118.26C74.8444 118.887 74.6212 120.59 73.5124 122.064C72.4036 123.538 70.8291 124.225 69.9956 123.598Z",
    fill: "white"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M74.7524 119.723C74.7524 121.11 73.6236 122.884 72.2399 123.684C70.8563 124.484 69.729 124.007 69.729 122.623C69.729 121.239 70.8579 119.462 72.2399 118.662C73.622 117.862 74.7524 118.336 74.7524 119.723Z",
    fill: "url(#paint109_linear_32758_33488)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2997 122.531C73.0237 122.112 73.614 121.178 73.614 120.449C73.6265 120.303 73.5991 120.156 73.5346 120.025C73.4701 119.893 73.371 119.782 73.2479 119.702C72.9721 119.541 72.5835 119.585 72.1819 119.817C71.4562 120.235 70.8676 121.168 70.8676 121.897C70.8549 122.043 70.8821 122.19 70.9463 122.321C71.0105 122.453 71.1093 122.564 71.2321 122.644C71.3481 122.709 71.4795 122.743 71.6127 122.741C71.8559 122.731 72.0927 122.659 72.2997 122.531ZM73.1302 119.906C73.2162 119.966 73.2845 120.048 73.3282 120.144C73.3719 120.239 73.3892 120.345 73.3785 120.449C73.3785 121.104 72.8415 121.946 72.1819 122.326C71.8594 122.515 71.5514 122.557 71.3498 122.441C71.2643 122.38 71.1965 122.298 71.1531 122.202C71.1098 122.107 71.0925 122.002 71.1031 121.897C71.1031 121.252 71.6401 120.401 72.2997 120.02C72.4704 119.913 72.6659 119.851 72.8673 119.841C72.9591 119.839 73.0499 119.861 73.1302 119.906Z",
    fill: "url(#paint110_linear_32758_33488)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1535 127.176C59.1535 120.635 64.4575 112.27 70.9984 108.493C73.1529 107.25 75.172 106.658 76.912 106.658C77.8396 106.644 78.7583 106.839 79.6003 107.229L77.7458 106.137C77.4694 106.107 77.1916 106.093 76.9137 106.093C75.0252 106.093 72.882 106.753 70.7178 108.003C67.4764 109.875 64.4285 112.891 62.1482 116.495C59.8679 120.099 58.6004 123.913 58.6004 127.174C58.6004 129.095 59.0438 130.741 59.8905 131.991L61.7982 133.104C60.1421 132.013 59.1535 129.998 59.1535 127.176Z",
    fill: "#516882"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M126.512 82.0503L126.277 82.0374C126.277 81.9261 126.87 70.7843 126.87 65.8673C126.87 60.989 125.151 58.1894 125.135 58.162C125.119 58.1346 115.385 36.7056 115.385 36.7056L115.601 36.6089L125.338 58.0443C125.438 58.2056 127.112 61.039 127.112 65.8673C127.106 70.7907 126.519 81.9374 126.512 82.0503Z",
    fill: "#3E3E3E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_32758_33488",
    x1: 87.0232,
    y1: 21.887,
    x2: 176.193,
    y2: 104.076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_32758_33488",
    x1: 86.6475,
    y1: 22.2933,
    x2: 175.819,
    y2: 104.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_32758_33488",
    x1: 86.3394,
    y1: 22.6289,
    x2: 175.51,
    y2: 104.816,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_32758_33488",
    x1: 86.2653,
    y1: 22.7094,
    x2: 175.436,
    y2: 104.897,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_32758_33488",
    x1: 86.2218,
    y1: 22.7562,
    x2: 175.394,
    y2: 104.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_32758_33488",
    x1: 86.2024,
    y1: 22.7772,
    x2: 175.373,
    y2: 104.966,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_32758_33488",
    x1: 86.1993,
    y1: 22.7821,
    x2: 175.369,
    y2: 104.969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_32758_33488",
    x1: 86.2089,
    y1: 22.7692,
    x2: 175.381,
    y2: 104.958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_32758_33488",
    x1: 86.233,
    y1: 22.745,
    x2: 175.403,
    y2: 104.932,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_32758_33488",
    x1: 86.4071,
    y1: 22.5562,
    x2: 175.577,
    y2: 104.744,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_32758_33488",
    x1: 86.4411,
    y1: 22.5193,
    x2: 175.613,
    y2: 104.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_32758_33488",
    x1: 86.1686,
    y1: 22.8142,
    x2: 175.339,
    y2: 105.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_32758_33488",
    x1: 85.7233,
    y1: 23.2981,
    x2: 174.893,
    y2: 105.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_32758_33488",
    x1: 85.1526,
    y1: 23.9156,
    x2: 174.324,
    y2: 106.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_32758_33488",
    x1: 84.4802,
    y1: 24.6446,
    x2: 173.652,
    y2: 106.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_32758_33488",
    x1: 83.7221,
    y1: 25.4673,
    x2: 172.893,
    y2: 107.656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_32758_33488",
    x1: 82.8884,
    y1: 26.3735,
    x2: 172.059,
    y2: 108.561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_32758_33488",
    x1: 81.9854,
    y1: 27.3539,
    x2: 171.156,
    y2: 109.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_32758_33488",
    x1: 81.0243,
    y1: 28.3958,
    x2: 170.196,
    y2: 110.583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_32758_33488",
    x1: 80.0259,
    y1: 29.4795,
    x2: 169.196,
    y2: 111.667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_32758_33488",
    x1: 78.9712,
    y1: 30.6245,
    x2: 168.141,
    y2: 112.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_32758_33488",
    x1: 77.8634,
    y1: 31.8263,
    x2: 167.033,
    y2: 114.014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_32758_33488",
    x1: 76.7072,
    y1: 33.0805,
    x2: 165.877,
    y2: 115.268,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_32758_33488",
    x1: 75.5039,
    y1: 34.385,
    x2: 164.674,
    y2: 116.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_32758_33488",
    x1: 74.2559,
    y1: 35.7399,
    x2: 163.426,
    y2: 117.927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_32758_33488",
    x1: 72.9658,
    y1: 37.1379,
    x2: 162.138,
    y2: 119.325,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_32758_33488",
    x1: 71.6369,
    y1: 38.5812,
    x2: 160.807,
    y2: 120.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_32758_33488",
    x1: 70.2693,
    y1: 40.0649,
    x2: 159.439,
    y2: 122.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_32758_33488",
    x1: 68.8308,
    y1: 41.6242,
    x2: 158.003,
    y2: 123.812,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_32758_33488",
    x1: 67.1762,
    y1: 43.4209,
    x2: 156.346,
    y2: 125.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_32758_33488",
    x1: 65.4217,
    y1: 45.3238,
    x2: 154.592,
    y2: 127.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_32758_33488",
    x1: 63.5431,
    y1: 47.3621,
    x2: 152.715,
    y2: 129.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_32758_33488",
    x1: 61.6757,
    y1: 49.3877,
    x2: 150.847,
    y2: 131.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_32758_33488",
    x1: 59.8195,
    y1: 51.4017,
    x2: 148.99,
    y2: 133.589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_32758_33488",
    x1: 57.9763,
    y1: 53.4031,
    x2: 147.146,
    y2: 135.59,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_32758_33488",
    x1: 56.1458,
    y1: 55.3881,
    x2: 145.318,
    y2: 137.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_32758_33488",
    x1: 54.3346,
    y1: 57.3541,
    x2: 143.505,
    y2: 139.541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_32758_33488",
    x1: 52.5432,
    y1: 59.2974,
    x2: 141.713,
    y2: 141.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_32758_33488",
    x1: 50.7674,
    y1: 61.223,
    x2: 139.938,
    y2: 143.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_32758_33488",
    x1: 49.0066,
    y1: 63.1338,
    x2: 138.177,
    y2: 145.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_32758_33488",
    x1: 47.4037,
    y1: 64.8724,
    x2: 136.575,
    y2: 147.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_32758_33488",
    x1: 45.9279,
    y1: 66.4737,
    x2: 135.098,
    y2: 148.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_32758_33488",
    x1: 44.6186,
    y1: 67.8943,
    x2: 133.79,
    y2: 150.082,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_32758_33488",
    x1: 43.4637,
    y1: 69.1476,
    x2: 132.635,
    y2: 151.333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_32758_33488",
    x1: 42.4236,
    y1: 70.3681,
    x2: 131.594,
    y2: 152.557,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_32758_33488",
    x1: 41.3286,
    y1: 71.4633,
    x2: 130.5,
    y2: 153.651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_32758_33488",
    x1: 40.3079,
    y1: 72.5727,
    x2: 129.478,
    y2: 154.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_32758_33488",
    x1: 39.3193,
    y1: 73.645,
    x2: 128.489,
    y2: 155.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_32758_33488",
    x1: 38.3614,
    y1: 74.6822,
    x2: 127.533,
    y2: 156.871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_32758_33488",
    x1: 37.4389,
    y1: 75.685,
    x2: 126.609,
    y2: 157.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_32758_33488",
    x1: 36.5521,
    y1: 76.6462,
    x2: 125.724,
    y2: 158.834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_32758_33488",
    x1: 35.7118,
    y1: 77.5575,
    x2: 124.882,
    y2: 159.745,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_32758_33488",
    x1: 34.936,
    y1: 78.4009,
    x2: 124.106,
    y2: 160.588,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_32758_33488",
    x1: 34.3458,
    y1: 79.0393,
    x2: 123.518,
    y2: 161.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_32758_33488",
    x1: 34.1991,
    y1: 79.1992,
    x2: 123.369,
    y2: 161.387,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_32758_33488",
    x1: 34.1588,
    y1: 79.2427,
    x2: 123.329,
    y2: 161.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_32758_33488",
    x1: 34.1088,
    y1: 79.2975,
    x2: 123.279,
    y2: 161.485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_32758_33488",
    x1: 34.0492,
    y1: 79.3637,
    x2: 123.219,
    y2: 161.551,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_32758_33488",
    x1: 33.9733,
    y1: 79.4443,
    x2: 123.145,
    y2: 161.632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_32758_33488",
    x1: 33.883,
    y1: 79.543,
    x2: 123.053,
    y2: 161.73,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_32758_33488",
    x1: 33.7686,
    y1: 79.6669,
    x2: 122.94,
    y2: 161.854,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_32758_33488",
    x1: 33.6235,
    y1: 79.8232,
    x2: 122.795,
    y2: 162.011,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_32758_33488",
    x1: 33.4284,
    y1: 80.0369,
    x2: 122.598,
    y2: 162.224,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_32758_33488",
    x1: 32.8881,
    y1: 80.6215,
    x2: 122.06,
    y2: 162.809,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#625551"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#A59D9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#D3D3D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#F8F8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_32758_33488",
    x1: 28.7854,
    y1: 51.8534,
    x2: 38.879,
    y2: 51.8534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_32758_33488",
    x1: 129.013,
    y1: 80.1754,
    x2: 164.466,
    y2: 80.1754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_32758_33488",
    x1: 149.236,
    y1: 67.1573,
    x2: 189.864,
    y2: 71.0777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_32758_33488",
    x1: 149.014,
    y1: 69.4587,
    x2: 189.641,
    y2: 73.3774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_32758_33488",
    x1: 148.699,
    y1: 72.7129,
    x2: 189.328,
    y2: 76.6333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_32758_33488",
    x1: 148.962,
    y1: 69.1877,
    x2: 190.049,
    y2: 73.1516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_32758_33488",
    x1: 149.623,
    y1: 63.1449,
    x2: 190.251,
    y2: 67.0653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_32758_33488",
    x1: 149.63,
    y1: 63.0742,
    x2: 190.259,
    y2: 66.9945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_32758_33488",
    x1: 157.693,
    y1: 64.2011,
    x2: 159.059,
    y2: 69.0605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_32758_33488",
    x1: 157.424,
    y1: 66.8606,
    x2: 156.525,
    y2: 70.3826,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#141920"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_32758_33488",
    x1: -386.283,
    y1: 49.1086,
    x2: -354.536,
    y2: 55.3947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#292F36"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_32758_33488",
    x1: 225.679,
    y1: 13.2946,
    x2: 38.5438,
    y2: 63.732,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_32758_33488",
    x1: 55.4733,
    y1: 103.798,
    x2: 50.5434,
    y2: 105.422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5F71"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_32758_33488",
    x1: 14.3232,
    y1: 74.2225,
    x2: -0.818048,
    y2: 79.1072,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6E7B8A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_32758_33488",
    x1: 229.141,
    y1: 15.3726,
    x2: 41.9076,
    y2: 67.0807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#636363"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_32758_33488",
    x1: 9.53508,
    y1: 107.101,
    x2: 25.3633,
    y2: 107.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3E3E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D1D1D1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_32758_33488",
    x1: -0.74378,
    y1: 95.8803,
    x2: 2.24126,
    y2: 97.9623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#546272"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_32758_33488",
    x1: 32.601,
    y1: 122.55,
    x2: 42.0415,
    y2: 122.55,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#626D7B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_32758_33488",
    x1: 53.9123,
    y1: 112.803,
    x2: 83.0643,
    y2: 112.803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_32758_33488",
    x1: 137.694,
    y1: 61.8049,
    x2: 165.579,
    y2: 61.8049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E3E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#525252"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#636363"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#555555"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3E3E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_32758_33488",
    x1: 129.013,
    y1: 80.1754,
    x2: 164.466,
    y2: 80.1754,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26323F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26323F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_32758_33488",
    x1: 149.236,
    y1: 67.1573,
    x2: 189.864,
    y2: 71.0777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#26313F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_32758_33488",
    x1: 149.012,
    y1: 69.4764,
    x2: 189.64,
    y2: 73.3968,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_32758_33488",
    x1: 148.597,
    y1: 72.7613,
    x2: 189.704,
    y2: 76.7285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_32758_33488",
    x1: 148.962,
    y1: 69.1877,
    x2: 190.049,
    y2: 73.1516,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_32758_33488",
    x1: 149.623,
    y1: 63.1449,
    x2: 190.251,
    y2: 67.0653,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_32758_33488",
    x1: 149.63,
    y1: 63.0742,
    x2: 190.259,
    y2: 66.9945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_32758_33488",
    x1: 157.693,
    y1: 64.2011,
    x2: 159.059,
    y2: 69.0605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#51647A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#29415D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_32758_33488",
    x1: 157.393,
    y1: 66.9752,
    x2: 156.554,
    y2: 70.2699,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_32758_33488",
    x1: 44.2798,
    y1: 132.948,
    x2: 79.734,
    y2: 132.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_32758_33488",
    x1: 64.5026,
    y1: 119.709,
    x2: 105.132,
    y2: 123.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_32758_33488",
    x1: 64.2799,
    y1: 122.008,
    x2: 104.909,
    y2: 125.929,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_32758_33488",
    x1: 63.9671,
    y1: 125.265,
    x2: 104.595,
    y2: 129.185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_32758_33488",
    x1: 64.2299,
    y1: 121.739,
    x2: 105.317,
    y2: 125.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_32758_33488",
    x1: 64.8897,
    y1: 115.697,
    x2: 105.519,
    y2: 119.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_32758_33488",
    x1: 64.896,
    y1: 115.626,
    x2: 105.525,
    y2: 119.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_32758_33488",
    x1: 72.9608,
    y1: 116.972,
    x2: 74.3271,
    y2: 121.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_32758_33488",
    x1: 72.69,
    y1: 119.412,
    x2: 71.7918,
    y2: 122.934,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_32758_33488",
    x1: 44.2798,
    y1: 132.948,
    x2: 79.734,
    y2: 132.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C2A3B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_32758_33488",
    x1: 64.5026,
    y1: 119.709,
    x2: 105.132,
    y2: 123.629,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_32758_33488",
    x1: 64.2783,
    y1: 122.028,
    x2: 104.908,
    y2: 125.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_32758_33488",
    x1: 63.8655,
    y1: 125.313,
    x2: 104.97,
    y2: 129.28,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_32758_33488",
    x1: 64.2299,
    y1: 121.739,
    x2: 105.317,
    y2: 125.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_32758_33488",
    x1: 64.8897,
    y1: 115.697,
    x2: 105.519,
    y2: 119.617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_32758_33488",
    x1: 64.896,
    y1: 115.626,
    x2: 105.525,
    y2: 119.546,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_32758_33488",
    x1: 72.9608,
    y1: 116.972,
    x2: 74.3271,
    y2: 121.832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292F36"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0D1D31"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_32758_33488",
    x1: 72.6609,
    y1: 119.527,
    x2: 71.8207,
    y2: 122.821,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4E4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9E6F63"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoVehicles);
export default __webpack_public_path__ + "static/media/no_vehicles.b09bb1a99db854337936ac59bfb68f9b.svg";
export { ForwardRef as ReactComponent };